<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-unclassified-messages" v-loading="loading">
    <wy-page-modal ref="pageModal" :onOpen="handlePageModalOpen" :onClose="handlePageModalClose">
      <wy-va-optimization-unclassified-messages-existing-intent ref="existingIntent" :controller="module" />
    </wy-page-modal>
    <wy-page-modal ref="pageModal2" :onOpen="handlePageModalOpen" :onClose="handlePageModalClose">
      <wy-va-optimization-unclassified-single-msg-existing-intent ref="singleExistingIntent" :controller="module" />
    </wy-page-modal>
    <div class="unclassified-msg-small-title">{{$t(currentPageInfo.subtitle)}}</div>
    <div class="unclassified-messages-title">
      <span>{{$t(currentPageInfo.title)}} <wy-page-tooltip />
      </span>

      <el-button v-if="isRoleAllow(4131) && actionedMessageList && actionedMessageList.length > 0" class="export-btn" round @click="handleExport">
        <div class="export-icon"></div>
        <span class="export-text">Export</span> 
      </el-button>
    </div>

    <div class="msg-flex-container">
      <div :class="(categoryList && categoryList.length > 0 ? 'suggested-category unclassified-table': 'unclassified-table unclassified-table-no-data')" style="min-width: 150; width: 100%;">
        <div class="unclassified-table-title">Suggested category<span class="percentage-of-total">% of total</span></div>
        <div class="unclassified-table-content" v-if="categoryList && categoryList.length > 0">
          <div :class="{'unclassified-table-data category': true, 'selected': (selectedCategory == item)}" v-for="(item, index) in categoryList" :key="index" @click="handleSelectCategory(item)">
            {{item.name}}
            <div class="ignore-wrap-div" @mouseover="mouseover($event, `Total: ${item.total}`)" @mouseout="mouseout">  
              <span class="unclassified-percentage">{{item.percent}}%</span>
            </div>
          </div>
        </div>
        <div class="no-data-flex" v-else>
          <img class="no-data-image" src="../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
          <span class="no-data-text">Sorry!</span>
          <span class="no-data-text-small">No data available yet.</span>
        </div>
      </div>

      <div :class="(categoryList && categoryList.length > 0 ? 'suggested-topic unclassified-table': 'unclassified-table unclassified-table-no-data')" style="min-width: 150; width: 100%;">
        <div class="unclassified-table-title">Suggested topic<span class="percentage-of-total">% of total</span></div>
        <div class="unclassified-table-content" v-if="categoryList && categoryList.length > 0" v-loading="loadingTopics">
          <div :class="{'unclassified-table-data topic': true, 'selected': (selectedTopic == item)}" v-for="(item, index) in topicList" :key="index" @click="handleSelectTopic(item)">
            {{item.name}}
            <div class="ignore-wrap-div" @mouseover="mouseover($event, `Total: ${item.total}`)" @mouseout="mouseout">
              <span class="unclassified-percentage">{{item.percent}}%</span>
            </div>
          </div>
        </div>
        <div class="no-data-flex" v-else>
          <img class="no-data-image" src="../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
          <span class="no-data-text">Sorry!</span>
          <span class="no-data-text-small">No data available yet.</span>
        </div>
      </div>

      <div :class="(categoryList && categoryList.length > 0 ? 'messages unclassified-table messages-table': 'unclassified-table unclassified-table-no-data messages-tables')" style="min-width: 150; width: 100%;">
        <div class="unclassified-table-title">Messages <span v-if="keywordSearchConfirmed!=''" class="current-keyword">Current search keyword: <span class="keyword-content">{{keywordSearchConfirmed}}</span></span></div>
        <div v-if="categoryList && categoryList.length > 0" class="div-search-input">
          <div class="search-button material-icons">search</div>
          <el-input
            ref="searchInput"
            v-model="searchMessageKeyword"
            class="search-inp"
            placeholder="Search all messages"
            @keypress.enter.native="handleKeywordSearch"
          ></el-input><i class="fas fa-times-circle" v-if="searchMessageKeyword!=''" @click="clearKeywordSearch"></i>
        </div>
        <div class="unclassified-table-content" v-if="categoryList && categoryList.length > 0" v-loading="loadingMessages">
          <el-collapse class="unclassified-msg-collapse" v-model="collapseSelected" @change="handleUnclassifiedCollapseExpand(collapseSelected)">
            <el-collapse-item name="toBeActioned" class="to-be-actioned-collapse" :style="{height: toBeActionedCollapseHeight}"
            :disabled="toBeActionedMessageList.length==0||toBeActionedSelected&&toBeActionedSelected.length>0" v-loading="loadingToBeActioned">
              <template slot="title">
                <div class="header-flex">
                  <span v-if="(messageList && messageList.length == 0)" class="unclassified-msg-title-percent">
                    <span class="messages-header">To be actioned</span> (N/A)
                  </span>
                  <span v-else class="unclassified-msg-title-percent">
                    <span class="messages-header">To be actioned</span> ({{toBeActionedMessagePercent}}%)
                    <span v-if="toBeActionedSelected.length>0" class="to-be-actioned-selected-info">{{toBeActionedSelected.length}} selected. <span class="clear-selected" @click="clearAllSelectedMessage($event, 'toBeActioned')">Clear selection.</span></span>
                  </span>
              
                  <div class="header-icon-container" v-if="isRoleAllow(4131) && toBeActionedSelected && toBeActionedSelected.length>0">
                    <img class="header-delete-icon" @mouseover="mouseover($event, 'discard message')" @mouseout="mouseout" @click="handleDiscards($event, 'toBeActioned')" src="../../assets/icons/icon_unclassified_msg_delete.svg" alt="delete icon">
                    <span class="unclassified-msg-icon-flex">
                      <div :class="{'unclassified-msg-n-icon': true}" @mouseover="mouseover($event, 'assign as candidate for new intent', 'right', 'right_header_1')" @mouseout="mouseout" @click="handleNewIntentSelects($event, 'toBeActioned')"></div>
                      <div :class="{'unclassified-msg-e-icon': true}" @mouseover="mouseover($event, 'assign as candidate for existing intent', 'right', 'right_header_2')" @mouseout="mouseout" @click="handleExitingIntentSelects($event, 'toBeActioned')"></div>
                    </span>
                  </div>
                </div>
              </template>
              
              <div v-if="isRoleAllow(4131)">
                <el-checkbox class="unclassified-msg-checkbox-all" 
                v-if="toBeActionedMessageList.length >= 1"
                :indeterminate="toBeActionedSelectedIsIndeterminate" :class="{'disabled-check-all':toBeActionedSelected.length==pageSize&&!toBeActionedSelected.includes(toBeActionedMessageList[0].message)}" v-model="toBeActionedSelectedCheckAll" @change="handleSelectedCheckAllChange('toBeActioned')">All</el-checkbox>
                
                <el-checkbox-group v-model="toBeActionedSelected" @change="handleSelectedChange('toBeActioned')">
                  <div class="unclassified-msg-flex-container" v-for="(item, index) in toBeActionedMessageList" :key="index">
                    
                    <el-checkbox class="unclassified-msg-checkbox" :key="item.message" :label="item.message" :disabled="toBeActionedSelected.length>=pageSize && !toBeActionedSelected.includes(item.message)">
                      <div @mouseover="mouseover($event, item.message)" @mouseout="mouseout" v-html="highlightKeyword(item.message, keywordSearchConfirmed)"></div>
                    </el-checkbox>

                    <span class="unclassified-msg-icon-flex" v-if="isRoleAllow(4131) && (!toBeActionedSelected || toBeActionedSelected.length==0)">
                        <div @click="handleDiscard($event, item)" @mouseover="mouseover($event, 'discard message')" @mouseout="mouseout" class="unclassified-msg-edit-delete"></div>
                        <div :class="{'unclassified-msg-n-icon': true}" @mouseover="mouseover($event, 'assign as candidate for new intent', 'right', 'right_1')" @mouseout="mouseout" @click="handleNewIntentSelect($event, item)"></div>
                        <div :class="{'unclassified-msg-e-icon': true}" @mouseover="mouseover($event, 'assign as candidate for existing intent', 'right', 'right_2')" @mouseout="mouseout" @click="handleExitingIntentSelect($event, item)"></div>
                    </span>
                  </div>
                </el-checkbox-group>
              </div>
              <div v-else>
                <div class="unclassified-msg-flex-container message" v-for="(item, index) in toBeActionedMessageList" :key="index">
                  <div @mouseover="mouseover($event, item.message)"  @mouseout="mouseout" v-html="highlightKeyword(item.message, keywordSearchConfirmed)"></div>
                </div>
              </div>
            </el-collapse-item>
            <div v-if="!isToBeActionedCollapseExpanded && toBeActionedMessageList.length >= 1" class="div-unclassified-pagination-footer">
              <div class="div-unclassified-page-infor">{{(paginationToBeActioned.pageNo-1)*pageSize + 1}} - {{((paginationToBeActioned.pageNo)*pageSize>paginationToBeActioned.totalRecord)?paginationToBeActioned.totalRecord:paginationToBeActioned.pageNo*pageSize}} of {{paginationToBeActioned.totalRecord}}</div>
              <div class="div-unclassified-pagination">
                <el-pagination
                  :disabled="loadingToBeActioned"
                  :page-size="paginationToBeActioned.pageSize"
                  :page-count="paginationToBeActioned.pageCount"
                  :current-page="paginationToBeActioned.pageNo"
                  @current-change="pageChanged($event, 'toBeActioned', paginationToBeActioned)"
                  layout="prev, next">
                </el-pagination>
              </div>
            </div>
            <!-- <div v-else class="div-unclassified-pagination-footer no-data">
              No items match your search.
            </div> -->
            <el-collapse-item name="actioned" class="actioned-collapse" :style="{height: actionedCollapseHeight}" 
            :disabled="actionedMessageList.length==0||actionedSelected&&actionedSelected.length>0" v-loading="loadingActioned">
              <template slot="title">
                <div class="header-flex">
                  <span v-if="(messageList && messageList.length == 0)"  class="unclassified-msg-title-percent">
                    <span class="messages-header">Actioned</span> (N/A)
                  </span>
                  <span v-else class="unclassified-msg-title-percent">
                    <span class="messages-header">Actioned</span> ({{actionedMessagePercent}}%)
                    <span v-if="actionedSelected.length>0" class="actioned-selected-info">{{actionedSelected.length}} selected. <span class="clear-selected" @click="clearAllSelectedMessage($event, 'actioned')">Clear selection.</span></span>
                  </span>
                  <div class="header-icon-container" v-if="isRoleAllow(4131) && actionedSelected && actionedSelected.length>0">
                    <img @mouseover="mouseover($event, 'to be actioned')" @mouseout="mouseout"  @click="handleResetAll($event, 'actioned')" style="margin-right: 21px;" class="header-reset" src="../../assets/icons/icon_unclassigied_msg_reset.svg" alt="">
      
                    <img class="header-delete-icon" @mouseover="mouseover($event, 'discard message')" @mouseout="mouseout" @click="handleDiscards($event, 'actioned')" src="../../assets/icons/icon_unclassified_msg_delete.svg" alt="delete icon">
                    <span class="unclassified-msg-icon-flex">
                      <div :class="{'unclassified-msg-n-icon': true}" @mouseover="mouseover($event, 'assign as candidate for new intent', 'right')" @mouseout="mouseout" @click="handleNewIntentSelects($event, 'actioned')"></div>
                        <div :class="{'unclassified-msg-e-icon': true}" @mouseover="mouseover($event, 'assign as candidate for existing intent', 'right')" @mouseout="mouseout" @click="handleExitingIntentSelects($event, 'actioned')"></div>
                    </span>
                  </div>
                </div>
              </template>
              <div v-if="isRoleAllow(4131)">
                <el-checkbox class="unclassified-msg-checkbox-all" v-if="actionedMessageList.length >= 1"
                :indeterminate="actionedSelectedIsIndeterminate" v-model="actionedSelectedCheckAll" :class="{'disabled-check-all':actionedSelected.length==pageSize&&!actionedSelected.includes(actionedMessageList[0].message)}" @change="handleSelectedCheckAllChange('actioned')">All</el-checkbox>
                
                <el-checkbox-group v-model="actionedSelected" @change="handleSelectedChange('actioned')">
                  <div class="unclassified-msg-flex-container" v-for="(item, index) in actionedMessageList" :key="index">

                    <el-checkbox class="unclassified-msg-checkbox" :key="item.message" :label="item.message" :disabled="actionedSelected.length>=pageSize && !actionedSelected.includes(item.message)">
                      <div @mouseover="mouseover($event, item.message)" @mouseout="mouseout" v-html="highlightKeyword(item.message, keywordSearchConfirmed)"></div>
                    </el-checkbox>

                    <span class="unclassified-msg-icon-flex" v-if="isRoleAllow(4131) && (!actionedSelected || actionedSelected.length==0)">
                      <img @mouseover="mouseover($event, 'to be actioned')" @mouseout="mouseout"  @click="handleReset($event, item)" style="margin-right: 21px;" class="header-reset-icon" src="../../assets/icons/icon_unclassigied_msg_reset.svg" alt="">

                      <div @mouseover="mouseover($event, 'discard message')" @mouseout="mouseout" @click="handleDiscard($event, item)" class="unclassified-msg-edit-delete"></div>
                      <div :class="{'unclassified-msg-n-icon': true, 'n-icon-selected': item.status=='N'}" @mouseover="mouseover($event, 'assign as candidate for new intent', 'right', 'right_1')" @mouseout="mouseout" @click="handleNewIntentSelect($event, item)"></div>
                      <div :class="{'unclassified-msg-e-icon': true, 'e-icon-selected': item.status=='E'}" @mouseover="mouseover($event, 'assign as candidate for existing intent', 'right', 'right_2')" @mouseout="mouseout" @click="handleExitingIntentSelect($event, item)"></div>
                    </span>
                  </div>
                </el-checkbox-group>
              </div>
              <div v-else>
                <div class="unclassified-msg-flex-container message" v-for="(item, index) in actionedMessageList" :key="index">
                  <div>{{item.message}}</div>
                </div>
              </div>
            </el-collapse-item>
            <!-- {{!isActionedCollapseExpanded}}{{ actionedMessageList.length >= 1}} -->
            <div v-if="!isActionedCollapseExpanded && actionedMessageList.length >= 1" class="div-unclassified-pagination-footer">
              <div class="div-unclassified-page-infor">{{(paginationActioned.pageNo-1)*pageSize + 1}} - {{((paginationActioned.pageNo)*pageSize>paginationActioned.totalRecord)?paginationActioned.totalRecord:paginationActioned.pageNo*pageSize}} of {{paginationActioned.totalRecord}}</div>
              <div class="div-unclassified-pagination">
                <el-pagination
                  :disabled="loadingActioned"
                  :page-size="paginationActioned.pageSize"
                  :page-count="paginationActioned.pageCount"
                  :current-page="paginationActioned.pageNo"
                  @current-change="pageChanged($event, 'actioned', paginationActioned)"
                  layout="prev, next">
                </el-pagination>
              </div>
            </div>
            <!-- <div v-else class="div-unclassified-pagination-footer no-data">
              No items match your search.
            </div> -->
            <el-collapse-item name="discarded" class="discarded-collapse" :style="{height: discardedCollapseHeight}" 
            :disabled="discardedMessageList.length==0||discardedSelected&&discardedSelected.length>0" v-loading="loadingDiscarded">
              <template slot="title">
                  <div class="header-flex"> 
                    <span v-if="(messageList && messageList.length == 0)"  class="unclassified-msg-title-percent">
                      <span class="messages-header">Discarded</span> (N/A)
                    </span>
                    <span v-else class="unclassified-msg-title-percent">
                      <span class="messages-header">Discarded</span> ({{discardedMessagePercent}}%)
                      <span v-if="discardedSelected.length>0" class="discarded-selected-info">{{discardedSelected.length}} selected. <span class="clear-selected" @click="clearAllSelectedMessage($event, 'discarded')">Clear selection.</span></span>
                    </span>
                    <div class="header-icon-container" v-if="isRoleAllow(4131) && discardedSelected && discardedSelected.length>0">
                      <span class="unclassified-msg-icon-flex">
                        <img @mouseover="mouseover($event, 'to be actioned', 'discard-header-reset')" @mouseout="mouseout"  @click="handleResetAll($event, 'discarded')" style="margin-right: 21px;" class="header-reset" src="../../assets/icons/icon_unclassigied_msg_reset.svg" alt="">
                        <div :class="{'unclassified-msg-n-icon': true}" @mouseover="mouseover($event, 'assign as candidate for new intent', 'right')" @mouseout="mouseout" @click="handleNewIntentSelects($event, 'discarded')"></div>
                        <div :class="{'unclassified-msg-e-icon': true}" @mouseover="mouseover($event, 'assign as candidate for existing intent', 'right')" @mouseout="mouseout" @click="handleExitingIntentSelects($event, 'discarded')"></div>
                      </span>
                    </div>
                  </div>
              </template>
              <div v-if="isRoleAllow(4131)">
                <el-checkbox class="unclassified-msg-checkbox-all" :indeterminate="discardedSelectedIsIndeterminate" v-model="discardedSelectedCheckAll" 
                v-if="discardedMessageList.length >= 1" :class="{'disabled-check-all':discardedSelected.length==pageSize&&!discardedSelected.includes(discardedMessageList[0].message)}" @change="handleSelectedCheckAllChange('discarded')">All</el-checkbox>
                
                <el-checkbox-group v-model="discardedSelected" @change="handleSelectedChange('discarded')">
                  <div class="unclassified-msg-flex-container" v-for="(item, index) in discardedMessageList" :key="index">
                  
                      <el-checkbox class="unclassified-msg-checkbox" :key="item.message" :label="item.message" :disabled="discardedSelected.length>=pageSize && !discardedSelected.includes(item.message)">
                        <div @mouseover="mouseover($event, item.message)" @mouseout="mouseout" v-html="highlightKeyword(item.message, keywordSearchConfirmed)"></div>
                      </el-checkbox>
                    
                    <span class="unclassified-msg-icon-flex" v-if="isRoleAllow(4131) && (!discardedSelected || discardedSelected.length==0)">
                      <img @mouseover="mouseover($event, 'to be actioned')" @mouseout="mouseout"  @click="handleReset($event, item)" style="margin-right: 21px;" class="header-reset-icon" src="../../assets/icons/icon_unclassigied_msg_reset.svg" alt="">
                      <div :class="{'unclassified-msg-n-icon': true, 'n-icon-selected': item.status=='N'}" @mouseover="mouseover($event, 'assign as candidate for new intent', 'right', 'right_1')" @mouseout="mouseout" @click="handleNewIntentSelect($event, item)"></div>
                      <div :class="{'unclassified-msg-e-icon': true, 'e-icon-selected': item.status=='E'}" @click="handleExitingIntentSelect($event, item)" @mouseover="mouseover($event, 'assign as candidate for existing intent', 'right', 'right_2')" @mouseout="mouseout"></div>
                    </span>
                  </div>
                </el-checkbox-group>
              </div>
              <div v-else>
                <div class="unclassified-msg-flex-container message" v-for="(item, index) in discardedMessageList" :key="index">
                  <div>{{item.message}}</div>
                </div>
              </div>
            </el-collapse-item>
            <div v-if="!isDiscardCollapseExpanded && discardedMessageList.length >= 1" class="div-unclassified-pagination-footer">
              <div class="div-unclassified-page-infor">{{(paginationDiscard.pageNo-1)*pageSize + 1}} - {{((paginationDiscard.pageNo)*pageSize>paginationDiscard.totalRecord)?paginationDiscard.totalRecord:paginationDiscard.pageNo*pageSize}} of {{paginationDiscard.totalRecord}}</div>
              <div class="div-unclassified-pagination">
                <el-pagination
                  :disabled="loadingDiscarded"
                  :page-size="paginationDiscard.pageSize"
                  :page-count="paginationDiscard.pageCount"
                  :current-page="paginationDiscard.pageNo"
                  @current-change="pageChanged($event, 'discarded', paginationDiscard)"
                  layout="prev, next">
                </el-pagination>
              </div>
            </div>
            <!-- <div v-else class="div-unclassified-pagination-footer no-data">
              No items match your search.
            </div> -->
          </el-collapse>
        </div>
        <div class="messages-no-data-flex" v-else>
          <img class="no-data-image" src="../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
          <span class="no-data-text">Sorry!</span>
          <span class="no-data-text-small">No data available yet.</span>
        </div>
      </div>
    </div>

    <el-tooltip
      ref="tableTooltip"
      class="abc"
      popper-class="cbs"
      placement="bottom"
      effect="dark"
      :content="tableTooltipContent">
    </el-tooltip>

    <!-- Discard intent popup -->
    <wy-dialog 
      ref="discardDialog"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Discard"
      :hasRememberOption="true"
      :controller="module">
    </wy-dialog>

    <!-- Export popup -->
    <el-dialog
      class="export-popper"
      v-if="exportVisible"
      :visible.sync="exportVisible"
      close-delay="0"
      :before-close="handleExportClose"
      width="90%">
      <div class="export-title" slot="title">Export saved candidates for new intents and candidates for existing intents</div>
      <table class="unclassified-msg-export-table" border="1">
      <thead>
        <tr class="table-titles">
          <td class=“suggested-category”>Suggested category</td>
          <td class=“suggested-topic”>Suggested topic</td>
          <td class=“message”>Message</td>
          <td class=“type”>Type</td>
          <td class=“assigned-intent”>Assigned intent</td>
        </tr>
      </thead>
      <tbody class="unclassified-msg-export-tody">
        <tr v-for="(item, index) in exportMessageList" :key="index">
          <td class=“suggested-category”>{{item.category}}</td>
          <td class=“suggested-topic”>{{item.topic}}</td>
          <!-- <el-tooltip :content="item.message" popper-class="unclassified-msg-popper" effect="dark" placement="bottom"> -->
            <td class=“message”>
              <div class="ellipsis" @mouseover="mouseover($event, item.message, 'dropdown')" @mouseout="mouseout">{{item.message}}</div>
            </td>
          <!-- </el-tooltip> -->
          <td class=“type”>{{`Candidate for ${item.status=='N' ? 'new' : 'existing'} intent`}}</td>
          <td class=“assigned-intent”>
            <div class="ellipsis" @mouseover="mouseover($event, item.assignedIntent ? item.assignedIntent : 'N/A', 'dropdown')" @mouseout="mouseout">{{item.assignedIntent ? item.assignedIntent : "N/A"}}</div>
          </td>
        </tr>
      </tbody>
    </table>
      
      <span slot="footer" class="dialog-footer">
        <el-button class="export-cancel-btn" @click="handleExportClose">Cancel</el-button>
        <el-button class="export-save-btn" type="primary" @click="handleExportConfirm">Export</el-button>
      </span>
    </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import ObjectsToCsv from 'objects-to-csv';
import WyDialog from '../widgets/wy-dialog.vue'
import WyPageTooltip from '../widgets/wy-page-tooltip.vue';
import WyPageModal from '../widgets/wy-page-modal';
import WyVaOptimizationUnclassifiedSingleMessagesExistingIntent from './wy-va-optimization-unclassified-single-msg-existing-intent.vue'
import WyVaOptimizationUnclassifiedMessagesExistingIntent from './wy-va-optimization-unclassified-messages-existing-intent.vue';
import WyUtils from '../../library/wy-utils';

export default Vue.extend({
  name: 'wy-va-optimization-unclassified-messages',
  components: {
    'wy-dialog': WyDialog,
    'wy-page-tooltip': WyPageTooltip,
    'wy-page-modal': WyPageModal,
    'wy-va-optimization-unclassified-single-msg-existing-intent': WyVaOptimizationUnclassifiedSingleMessagesExistingIntent,
    'wy-va-optimization-unclassified-messages-existing-intent': WyVaOptimizationUnclassifiedMessagesExistingIntent
  },

  data() {
    return {
      module: this,
      loading: false,
      exportVisible: false,
      tableTooltipContent: null,
      initDate: null,

      intentList: null,
      categoryList: null,
      topicList: null,
      messageList: null,
      messageAllList: [],

      searchMessageKeyword: '',
      keywordSearchConfirmed: '',
      
      selectedCategory: null,
      selectedIntent: null,
      selectedTopic: null,
      selectedMessage: null,
      clonedMessages: null,
      
      isToBeActionedCollapseExpanded: false,
      isActionedCollapseExpanded: false,
      isDiscardCollapseExpanded: false,

      selectedAll: false,

      //collapseSelected: ["actioned", "toBeActioned", "discarded"],
      collapseSelected: [],

      loadingCategories: false,
      loadingTopics: false,
      loadingMessages: false,
      loadingToBeActioned: false,
      loadingActioned: false,
      loadingDiscarded: false,

      unCheckAll: false,

      toBeActionedCollapseHeight: '42px',
      toBeActionedSelectedIsIndeterminate: false,
      toBeActionedSelectedCheckAll: false,
      toBeActionedSelected: [],
      toBeActionedSelectedDelaySort: [],
      toBeActionedSelectedObjectList: [],

      assignToSuggestedIntents: false,
      assignToOneIntent: false,

      actionedCollapseHeight: '42px',
      actionedSelectedIsIndeterminate: false,
      actionedSelectedCheckAll: false,
      actionedSelected: [],
      actionedSelectedDelaySort: [],
      actionedSelectedObjectList: [],

      discardedCollapseHeight: '42px',
      discardedSelectedIsIndeterminate: false,
      discardedSelectedCheckAll: false,
      discardedSelected: [],
      discardedSelectedDelaySort: [],
      discardedSelectedObjectList: [],
      noShowNextTime: false,

      //pagenation
      pageItemStart: 1,
      pageItemEnd: 1,
      pageSize: 100,
      pageCount: 1,
      pageNo: 1,
      paginationToBeActioned: {},
      paginationActioned: {},
      paginationDiscard: {},

      // cancelTooltips: false
      preMsgObj: null,
    }
  },

  watch: {
    collapseSelected(sections) {
      let numOfSelected = sections.length;
      let numOfNotSelected = 3 - numOfSelected;
      let minusHeight = (numOfNotSelected * 42) / numOfSelected;
      // let footerHeight = 0;
      let footerHeight = Math.pow(numOfNotSelected, 2) * 17
      this.toBeActionedCollapseHeight = sections.includes('toBeActioned') ? `calc(${((100/numOfSelected)).toFixed(2)}% - ${minusHeight - footerHeight}px)` : '42px';
      this.actionedCollapseHeight = sections.includes('actioned') ? `calc(${((100/numOfSelected)).toFixed(2)}% - ${minusHeight - footerHeight}px)` : '42px';
      this.discardedCollapseHeight = sections.includes('discarded') ? `calc(${((100/numOfSelected)).toFixed(2)}% - ${minusHeight - footerHeight}px)` : '42px';
      this.handleUnclassifiedCollapseExpand(sections);
    },
    toBeActionedMessageList(newList) {
      if(newList.length > 0) {
        // if(!this.collapseSelected.includes('toBeActioned')) this.collapseSelected.push('toBeActioned');
        let existCount = 0;
        let noExistCount = 0;
        newList.forEach(item => {
          this.toBeActionedSelected.includes(item.message) ? existCount ++ : noExistCount ++
        })
        if(existCount == newList.length) {
          this.toBeActionedSelectedCheckAll = true;
          this.toBeActionedSelectedIsIndeterminate = false;
        }
        else if(existCount > 0) {
          this.toBeActionedSelectedCheckAll = false;
          this.toBeActionedSelectedIsIndeterminate = true;
        }
        else {
          this.toBeActionedSelectedCheckAll = false;
          this.toBeActionedSelectedIsIndeterminate = false;
        }
      }
      else {
        this.toBeActionedSelectedCheckAll = false;
        const index = this.collapseSelected.indexOf("toBeActioned");
        if(index > -1) {
          this.collapseSelected.splice(index, 1);
        }
        if(this.paginationToBeActioned.totalRecord > 0) {
          if(!this.collapseSelected.includes('toBeActioned')) this.collapseSelected.push('toBeActioned');
        }
      }
    },
    actionedMessageList(newList) {
      if(newList.length > 0) {
        // if(!this.collapseSelected.includes('actioned')) this.collapseSelected.push('actioned');
        let existCount = 0;
        let noExistCount = 0;
        newList.forEach(item => {
          this.actionedSelected.includes(item.message) ? existCount ++ : noExistCount ++
        })
        if(existCount == newList.length) {
          this.actionedSelectedCheckAll = true;
          this.actionedSelectedIsIndeterminate = false;
        }
        else if(existCount > 0) {
          this.actionedSelectedCheckAll = false;
          this.actionedSelectedIsIndeterminate = true;
        }
        else {
          this.actionedSelectedCheckAll = false;
          this.actionedSelectedIsIndeterminate = false;
        }
      }
      else {
        this.actionedSelectedCheckAll = false;
        const index = this.collapseSelected.indexOf("actioned");
        if(index > -1) {
          this.collapseSelected.splice(index, 1);
        }
        if(this.paginationActioned.totalRecord > 0) {
          if(!this.collapseSelected.includes('actioned')) this.collapseSelected.push('actioned');
        }
      }
    },
    discardedMessageList(newList) {
      if(newList.length > 0) {
        // if(!this.collapseSelected.includes('discarded')) this.collapseSelected.push('discarded');
        let existCount = 0;
        let noExistCount = 0;
        newList.forEach(item => {
          this.discardedSelected.includes(item.message) ? existCount ++ : noExistCount ++
        })
        if(existCount == newList.length) {
          this.discardedSelectedCheckAll = true;
          this.discardedSelectedIsIndeterminate = false;
        }
        else if(existCount > 0) {
          this.discardedSelectedCheckAll = false;
          this.discardedSelectedIsIndeterminate = true;
        }
        else {
          this.discardedSelectedCheckAll = false;
          this.discardedSelectedIsIndeterminate = false;
        }
      }
      else {    
        this.discardedSelectedCheckAll = false;
        const index = this.collapseSelected.indexOf("discarded");
        if(index > -1) {
          this.collapseSelected.splice(index, 1);
        }
        if(this.paginationDiscard.totalRecord > 0) {
          if(!this.collapseSelected.includes('discarded')) this.collapseSelected.push('discarded');
        }
      }
    },
    isCheckedAll(val) {
      this.selectedAll = val;
    },
    toBeActionedSelected(newList) {
      this.toBeActionedSelectedObjectList = this.getSelectedObjList(this.toBeActionedSelectedObjectList, newList)
    },
    actionedSelected(newList) {
      this.actionedSelectedObjectList = this.getSelectedObjList(this.actionedSelectedObjectList, newList)
    },
    discardedSelected(newList) {
      this.discardedSelectedObjectList = this.getSelectedObjList(this.discardedSelectedObjectList, newList)
    },
  },

  computed: {
    ...mapGetters(['dataModel', 'config', 'currentPageInfo', 'isRoleAllow', 'isLoggedIn']),

    totalNumberOfMessages() {
      return this.paginationToBeActioned.totalRecord + this.paginationActioned.totalRecord + this.paginationDiscard.totalRecord
    },

    toBeActionedMessageList() {
      return this.messageList ? this.messageList.filter(item => item.status=='I').slice(0, this.pageSize).sort((a) => (this.toBeActionedSelectedDelaySort.includes(a.message)) ? -1 : 1) : [];
    },
    toBeActionedMessagePercent() {
      return this.messageList ? (this.paginationToBeActioned.totalRecord/this.totalNumberOfMessages * 100).toFixed(2) : 0.00;
    },

    actionedMessageList() {
      return this.messageList ? this.messageList.filter(item => (item.status=='E' || item.status=='N')).slice(0, this.pageSize).sort((a) => (this.actionedSelectedDelaySort.includes(a.message)) ? -1 : 1) : [];
    },
    actionedMessagePercent() {
      return this.messageList ? (this.paginationActioned.totalRecord/this.totalNumberOfMessages * 100).toFixed(2) : 0.00;
    },

    discardedMessageList() {
      return this.messageList ? this.messageList.filter(item => item.status=='D').slice(0, this.pageSize).sort((a) => (this.discardedSelectedDelaySort.includes(a.message)) ? -1 : 1) : [];
    },
    discardedMessagePercent() {
      return this.messageList ? (this.paginationDiscard.totalRecord/this.totalNumberOfMessages * 100).toFixed(2) : 0.00;
    },

    exportMessageList() {
      return this.messageList ? this.messageList.filter(item => (item.status=='E' || item.status=='N')).sort((a, b) => (a.status > b.status) ? 1 : -1) : [];
    },

    isCheckedAll() {
      //return (this.clonedMessages && this.clonedMessages.length > 0) ? this.clonedMessages.find(el => !el.selected)==null : true;
      let isSelectedAll = true;
      if(this.clonedMessages && this.clonedMessages.length > 0) {
        this.clonedMessages.forEach(item => {
          if(!item.selected) {
            isSelectedAll = false
          }
        })
      }
      return isSelectedAll
    },

    enableSuggestedIntents() {
      return !this.config.api.configs.disableSuggestedIntents || this.config.api.configs.disableSuggestedIntents===false;
    }
  },

  methods: {
    ...mapActions(['fetchOptimizationUnclassifiedCategories', 'fetchOptimizationUnclassifiedTopics', 'fetchOptimizationUnclassifiedMessagesWithToBeActioned', 'fetchOptimizationUnclassifiedMessagesWithActioned', 'fetchOptimizationUnclassifiedMessagesWithDiscard', 'saveOptimizationUnclassifiedMessages', 'fetchOptimizationUnclassifiedIntents']),

    // getCollapseHeight(section) {
    //   let heightPercent = '50px';
    //   if(this.collapseSelected.length > 0 && this.collapseSelected.includes(section)) {
    //     heightPercent = `calc(${((100/this.collapseSelected.length)).toFixed(0)}% - 50px)`;
    //   }

    //   return heightPercent;
    // },

    handleExport() {
      this.exportVisible = true;
    },

    handleExportClose(){
      this.exportVisible = false;
    },
    handleUnclassifiedCollapseExpand(sections){
      if(sections.includes('toBeActioned')){
        this.isToBeActionedCollapseExpanded = false;
      }
      else {
        this.isToBeActionedCollapseExpanded = true;
      }
      if(sections.includes('actioned')){
        this.isActionedCollapseExpanded = false;
      }
      else {
        this.isActionedCollapseExpanded = true;
      }
      if(sections.includes('discarded')){
        this.isDiscardCollapseExpanded = false;
      }
      else {
        this.isDiscardCollapseExpanded = true;
      }
    },

    mouseover(e, tooltips, type, position) {
      e.stopPropagation();
      let ignoreClassName = e.target.className != 'assigned-intent' && e.target.className != 'el-select-dropdown__item' && e.target.className != 'el-select-dropdown__item hover' 
      && e.target.className != 'ignore-wrap-div' && e.target.className != 'existing-intent-popover-item' && e.target.className != 'el-select__caret el-input__icon el-icon-arrow-up' 
      && e.target.className != 'el-select el-select--mini'
      if(tooltips && tooltips.trim() != '' && ignoreClassName) {
        // console.log(e, e.target, e.target.className)
        let tooltipsEl = document.querySelector(".site-tooltips");
        if(tooltipsEl) {
          tooltipsEl.innerHTML = tooltips
          tooltipsEl.style.display = 'block';
          tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;
          if(type == "right") {
            tooltipsEl.style.right = "10px";
            tooltipsEl.style.left = "unset";
          }
          if(type == "left") {
            tooltipsEl.style.left = "10px";
            tooltipsEl.style.right = "unset";
          }
          if(!type || type == "normal") {
            tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width/2 + 10}px`;
          }
          if(tooltipsEl.classList.contains("right_1")) {
            tooltipsEl.classList.remove("right_1")
          }
          if(tooltipsEl.classList.contains("right_2")) {
            tooltipsEl.classList.remove("right_2")
          }
          if(tooltipsEl.classList.contains("right_header_1")) {
            tooltipsEl.classList.remove("right_header_1")
          }
          if(tooltipsEl.classList.contains("right_header_2")) {
            tooltipsEl.classList.remove("right_header_2")
          }
          
          if(position) {
            tooltipsEl.classList.add(position)
          }
          tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height + 5}px`;
        }
      }
      else {
        e.preventDefault();
      }
      // let ignoreClassName = e.target.className != 'assigned-intent' && e.target.className != 'el-select-dropdown__item' && e.target.className != 'el-select-dropdown__item hover' && e.target.className != 'ignore-wrap-div' && e.target.className != 'existing-intent-popover-item' && e.target.className != 'el-select__caret el-input__icon el-icon-arrow-up' && e.target.className != 'el-select el-select--mini'
      // if(tooltips && ignoreClassName) {
      //   // console.log(e, e.target, e.target.className)
      //   let span = document.createElement("div")
      //   span.append(tooltips)
      //   span.classList.add("tooltips");
      //   let dom = e.target;
      //   dom.parentNode.append(span)
      //   span.style.top = `${dom.getBoundingClientRect().top - 50}px`;
      //   if(type == 'discarded') {
      //     span.style.right = `50px`;
      //   }
      //   if(type == 'reset' || type == 'discard-header-reset') {
      //     span.style.right = `100px`;
      //   }
      //   if(type == 'action-item-reset') {
      //     span.style.right = `110px`;
      //   }
      //   if(type == 'action-header-reset') {
      //     span.style.right = `130px`;
      //   }
      //   if(type == 'discard-reset') {
      //     span.style.right = `80px`;
      //   }
      //   if(type == 'dropdown' || type == 'el-checkbox unclassified-msg-checkbox is-checked') {
      //   // if(type == 'dropdown') {
      //     // console.log(e.target.getBoundingClientRect())
      //     span.style.top = `unset`;
      //   }
      //   if(type == 'controlButton') {
      //     span.style.left = `${e.layerX - span.getBoundingClientRect().width + 60}px`;
      //     // console.log("left...", `${e.layerX}px`, )
      //   }
      //   if(type == 'fixed') {
      //     // console.log(e.target.getBoundingClientRect())
      //     span.style.top = `${dom.getBoundingClientRect().top + 35}px`;
      //     // span.style.top = `${e.layerY + 35}px`;
          
      //   }
      // }
      // else {
      //   e.preventDefault();
      // }
    },
    mouseout(e) {
      // console.log("out....",e, e.target.className)
      e.stopPropagation();
      // if(e.target.parentNode.querySelector(".tooltips")) {
      //   e.target.parentNode.querySelector(".tooltips").remove();
      // }
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.style.display = 'none';
      }
    },

    handleAssignToSuggestedIntents(clonedMessages){
      this.assignToSuggestedIntents = true;
      this.assignToOneIntent = false;

      clonedMessages.filter(el=> el.selected).map(el => el.assignedIntent=el.suggestedIntent);
    },
    async handleExportConfirm() {
      let exportItems = this.actionedMessageList.map(item => {
        return {
          "Suggested category": item.category,
          "Suggested topic": item.topic,
          "Message": item.message,
          "Type": (`Candidate for ${item.status=='N' ? 'new' : 'existing'} intent`),
          "Assigned intent": item.assignedIntent ? item.assignedIntent : "N/A",
        }
      });

      const csv = new ObjectsToCsv(exportItems);
      const csvContent = await csv.toString();
      //let csvContent = csvHeaders + WyUtils.convertObjToCSV(exportItems);
      let exportedFilenmae = 'Candidates_for_new_intents_existing_intents.csv';
      let blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      let downloadLink = document.createElement("a");
      if (downloadLink.download !== undefined) {
        let url = URL.createObjectURL(blob);
        downloadLink.setAttribute("href", url);
        downloadLink.setAttribute("download", exportedFilenmae);
        downloadLink.style.visibility = 'hidden';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }

      this.exportVisible = false;
    },

    handleSelectedCheckAllChange(section) {
      if(this[`${section}Selected`].length < this.pageSize) {
        if(this[`${section}SelectedCheckAll`] || !this[`${section}SelectedIsIndeterminate`]) {
          let list = this[`${section}MessageList`].map(item => item.message);
          let totalList = _.union(this[`${section}Selected`], list)
          if(totalList.length > this.pageSize) {
            let removeNumber = this.pageSize - this[`${section}Selected`].length;
            list.splice(removeNumber)
            this[`${section}Selected`] = _.union(this[`${section}Selected`], list)
            this[`${section}SelectedCheckAll`] = false;
            this[`${section}SelectedIsIndeterminate`] = true;
            //showing alert msg
            if(!this.preMsgObj) {
              this.preMsgObj = this.$message({
                message: `Sorry! You can only select a maximum of ${this.pageSize} messages.`,
                type: 'warning',
                duration: 5000,
                customClass: "unclassified-limitation-warning",
                onClose: ()=>{
                  this.preMsgObj = null;
                }
              });
            }
          }
          else {
            if(this[`${section}SelectedCheckAll`]) {
              this[`${section}Selected`] = _.union(this[`${section}Selected`], list)
              this[`${section}SelectedCheckAll`] = true;
              this[`${section}SelectedIsIndeterminate`] = false;
            }
            else {
              this[`${section}Selected`] = _.difference(this[`${section}Selected`], list);
              this[`${section}SelectedIsIndeterminate`] = false;
            }
          }
        }
        else {
          let list = this[`${section}MessageList`].map(item => item.message);
          this[`${section}Selected`] = _.difference(this[`${section}Selected`], list)
          this[`${section}SelectedIsIndeterminate`] = false;
        }
        // this[`${section}Selected`] = this[`${section}SelectedCheckAll`] ? this[`${section}MessageList`].map(item => item.message) : [];
      }
      else {
        if(!this[`${section}SelectedCheckAll`] || this[`${section}SelectedIsIndeterminate`]) {
          let list = this[`${section}MessageList`].map(item => item.message);
          this[`${section}Selected`] = _.difference(this[`${section}Selected`], list)
        }
        this[`${section}SelectedCheckAll`] = false;
        this[`${section}SelectedIsIndeterminate`] = false;
      }
    },

    clearAllSelectedMessage(e, section) {
      e.stopPropagation();
      switch(section) {
        case "toBeActioned":
          this.toBeActionedSelected = [];
          this.toBeActionedSelectedObjectList = [];
          this[`${section}SelectedCheckAll`] = false;
          this[`${section}SelectedIsIndeterminate`] = false;
          break;
        case "actioned":
          this.actionedSelected = [];
          this.actionedSelectedObjectList = [];
          this[`${section}SelectedCheckAll`] = false;
          this[`${section}SelectedIsIndeterminate`] = false;
          break;
        case "discarded":
          this.discardedSelected = [];
          this.discardedSelectedObjectList = [];
          this[`${section}SelectedCheckAll`] = false;
          this[`${section}SelectedIsIndeterminate`] = false;
          break;
      }
    },

    handleSelectedChange(section) {
      let checkedCount = this[`${section}Selected`].length;
      this[`${section}SelectedCheckAll`] = checkedCount === this[`${section}MessageList`].length;
      this[`${section}SelectedIsIndeterminate`] = checkedCount > 0 && checkedCount < this[`${section}MessageList`].length;

      setTimeout(() => {
        this[`${section}SelectedDelaySort`] = this[`${section}Selected`];
      }, 200)
    },

    handleTooltipOver(e, content) {
      if(this.$refs.tableTooltip){
        this.$refs.tableTooltip.categoryList
        this.$refs.tableTooltip.hide();
        this.$refs.tableTooltip.handleClosePopper();
        this.$refs.tableTooltip.referenceElm = e.target;
      }
      this.tableTooltipContent = content;

      setTimeout(() => {
        if(this.$refs.tableTooltip){
          this.$refs.tableTooltip.show();
          this.$refs.tableTooltip.handleShowPopper();
        }
      }, 1000)
    },

    handleTooltipOut() {
      if(this.$refs.tableTooltip){
        this.$refs.tableTooltip.hide();
        this.$refs.tableTooltip.handleClosePopper();
      }
    },

    async handleNewIntentSelect(event, item) {     
      event.stopPropagation();
      let cloneItem = JSON.parse(JSON.stringify(item));
      if(cloneItem.status != 'N') {
        // add to new intent status
        cloneItem.assignedIntent = null;
        cloneItem.status = 'N';
      }
      else {
        // remove from new intent status
        cloneItem.assignedIntent = null;
        cloneItem.status = 'I';
      }
      let res = await this.saveOptimizationUnclassifiedMessages([cloneItem]);
      if(res.status == 200) {
        if(cloneItem.status == 'N') {
          event.target.classList.add('n-icon-selected-delay-active');
        }
        else {
          event.target.classList.add('n-icon-selected-delay-inactive');
        }
        let status = item.status;
        setTimeout(() => {
          event.target.classList.remove('n-icon-selected-delay-active');
          event.target.classList.remove('n-icon-selected-delay-inactive');
          item.status = cloneItem.status;
          item.assignedIntent = cloneItem.assignedIntent;
          
          //toBeActioned => actioned
          if(status  == 'I') {
            this.handlePagenationWhenEmptyMessages('toBeActioned', 'actioned', 1)
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned)
          }
          //actioned => toBeActioned
          if(status  == 'N') {
            this.handlePagenationWhenEmptyMessages('actioned', 'toBeActioned', 1)
            this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned)
          }
          //discarded => actioned
          if(status  == 'D') {
            this.handlePagenationWhenEmptyMessages('discarded', 'actioned', 1)
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned)
          }
        }, 500)
      }
    },

    async handleNewIntentSelects(event, section) {   
      event.stopPropagation();
      let selectedItems = this[`${section}SelectedObjectList`];
      if(selectedItems.length > 0) {
        let cloneItems = [];
        selectedItems.forEach(item => {
          let cloneItem = JSON.parse(JSON.stringify(item));
          cloneItem.status = 'N';
          cloneItem.selected = true;
          cloneItem.originItem = item;
          cloneItem.intentList = null;
          cloneItems.push(cloneItem);
        })
        if(cloneItems.length > 0) {
          let res = await this.saveOptimizationUnclassifiedMessages(cloneItems);
          // let res={status: 200}
          if(res.status == 200) {
            let numberOfUpdatedItems = selectedItems.length;
            cloneItems.map(updatedItem => {
              updatedItem.originItem.status = updatedItem.status;
              updatedItem.originItem.assignedIntent = updatedItem.assignedIntent;
              this.messageList.forEach(item => {
                if(updatedItem.hid == item.hid) {
                  item.status = updatedItem.status;
                }
              })
            });
            this[`${section}SelectedIsIndeterminate`] = false;
            this[`${section}SelectedCheckAll`] = false;
            this[`${section}Selected`].splice(0, this[`${section}Selected`].length);
            setTimeout(() => {
              //toBeActioned => actioned
              if(section  == 'toBeActioned') {
                this.handlePagenationWhenEmptyMessages(section, 'actioned', numberOfUpdatedItems)
                this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned)
              }
              //actioned => toBeActioned
              if(section  == 'actioned') {
                this.handlePagenationWhenEmptyMessages(section, 'toBeActioned', numberOfUpdatedItems)
                this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned)
              }
              //discarded => actioned
              if(section  == 'discarded') {
                this.handlePagenationWhenEmptyMessages(section, 'actioned', numberOfUpdatedItems)
                this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned)
              }
            }, 100);
          }
        }
      }
      this.mouseout(event);
    },

    async handleReset(event=null, item) {
      if(event !== null){
        event.stopPropagation();
      }
      let originStatus = item.status;
      let cloneItem = JSON.parse(JSON.stringify(item));
      cloneItem.status = 'I';
      cloneItem.assignedIntent = null;

      let res = await this.saveOptimizationUnclassifiedMessages([cloneItem]);
      if(res.status == 200) {
        item.status = cloneItem.status;
        item.assignedIntent = cloneItem.assignedIntent;
      }
      if(this.selectedMessage){
        this.selectedMessage.status = 'E';
        if(res.status == 200) {
          this.selectedMessage.originItem.status = this.selectedMessage.status;
          this.selectedMessage.originItem.assignedIntent = this.selectedMessage.assignedIntent;
          this.selectedMessage = null;
        }
      }
      //  call api when current page is empty
      if(originStatus == "E" || originStatus == "N") {
        this.handlePagenationWhenEmptyMessages('actioned', 'toBeActioned', 1);
        this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned)
      }
      if(originStatus == "D") {
        this.handlePagenationWhenEmptyMessages('discarded', 'toBeActioned', 1);
        this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned)
      }
      // if(this.messageList.filter(item => item.status=='I').length > this.pageSize) {
      //   this.messageList = this.messageList.filter(item => item.status!='I').concat(this.messageList.filter(item => item.status=='I').slice(0, this.pageSize))
      // }
    },
    
    async handleResetAll(event, section) {
      event.stopPropagation();
      let selectedItems = this[`${section}SelectedObjectList`];
      if(selectedItems.length > 0) {
        let cloneItems = [];
        selectedItems.forEach(item => {
          let cloneItem = JSON.parse(JSON.stringify(item));
          cloneItem.status = 'I';
          cloneItem.selected = true;
          cloneItem.originItem = item;
          cloneItem.intentList = null;
          cloneItems.push(cloneItem);
        })  
        if(cloneItems.length > 0) {
          let res = await this.saveOptimizationUnclassifiedMessages(cloneItems);
          if(res.status == 200) {
            let numberOfUpdatedItems = selectedItems.length;
            cloneItems.map(updatedItem => {
              updatedItem.originItem.status = updatedItem.status;
              updatedItem.originItem.assignedIntent = updatedItem.assignedIntent;
              this.messageList.forEach(item => {
                if(updatedItem.hid == item.hid) {
                  item.status = updatedItem.status;
                }
              })
            });

            this[`${section}SelectedIsIndeterminate`] = false;
            this[`${section}SelectedCheckAll`] = false;
            this[`${section}Selected`].splice(0, this[`${section}Selected`].length);
            // this[`${section}SelectedObjectList`] = [];
            
             // call api when current page is empty
            this.handlePagenationWhenEmptyMessages(section, 'toBeActioned', numberOfUpdatedItems);
            this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned);
          }
        }
      }
      this.mouseout(event);
    },
    async handleExitingIntentSave() {
      if(this.selectedMessage) {
        let status = this.selectedMessage.status;
        this.selectedMessage.status = 'E';
        let res = await this.saveOptimizationUnclassifiedMessages([this.selectedMessage]);
        if(res.status == 200) {
          this.selectedMessage.originItem.status = this.selectedMessage.status;
          this.selectedMessage.originItem.assignedIntent = this.selectedMessage.assignedIntent;
          this.selectedMessage = null;

          if (status == 'I') {
            this.handlePagenationWhenEmptyMessages('toBeActioned', 'actioned', 1);
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned);
          } else if (status == 'D') {
            this.handlePagenationWhenEmptyMessages('discarded', 'actioned', 1);
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned);
          }

          // this.$refs.existingIntentPopover.doClose();
          this.handlePageModalClose()

        }
      }
    },

    async handleExitingIntentsSave() {      
      if(this.clonedMessages) {
        const updateMessages = this.clonedMessages.filter(item => item.selected).filter(item => item.assignedIntent);
        let numberOfUpdatedItems = updateMessages.length
        let res = await this.saveOptimizationUnclassifiedMessages(updateMessages);
        if(res.status == 200) {
          let status = '';
          updateMessages.map(updateMessage => {
            let foundMessage = this.messageList.find(item => item.message==updateMessage.message);
            if(foundMessage) {
              status = foundMessage.status;
              foundMessage.message = updateMessage.message;
              foundMessage.status = updateMessage.status;
              foundMessage.assignedIntent = updateMessage.assignedIntent;              
            }
            this.clonedMessages = null;
          });
          if(status == 'I') {
            this.handlePagenationWhenEmptyMessages('toBeActioned', 'actioned', numberOfUpdatedItems);
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned);
            this.toBeActionedSelected = [];
            this.toBeActionedSelectedObjectList = [];
          }
          if(status == 'N' || status == 'E') {
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned);
            this.actionedSelected = [];
            this.actionedSelectedObjectList = [];
          }
          if(status == 'D') {
            this.handlePagenationWhenEmptyMessages('discarded', 'actioned', numberOfUpdatedItems);
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned);
            this.discardedSelected = [];
            this.discardedSelectedObjectList = [];
          }
          this.handlePageModalClose()
        }
      }
    },

    async handleExitingIntentSelect(event, item) {
      event.stopPropagation();

      if(item.status != 'E') {
        // add to existing intent status
        this.selectedMessage = JSON.parse(JSON.stringify(item));
        this.selectedMessage.assignedIntent = item.suggestedIntent;
        this.selectedMessage.originItem = item;

        // if(true) {
          // this.$refs.existingIntentPopover.doClose();
          // this.$refs.existingIntentPopover.referenceElm = event.target;
          setTimeout(() => {
            //this.$refs.existingIntentPopover.doShow();
            this.$refs.pageModal2.open();  
          }, 300);
        // }
      }
      else {
        // remove from existing intent status
        let cloneItem = JSON.parse(JSON.stringify(item));
        cloneItem.status = 'I';
        cloneItem.assignedIntent = null;

        let res = await this.saveOptimizationUnclassifiedMessages([cloneItem]);
        if(res.status == 200) {
          item.status = cloneItem.status;
          item.assignedIntent = cloneItem.assignedIntent;
          this.handlePagenationWhenEmptyMessages('actioned', 'toBeActioned', 1);
          this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned);
        }
      }
    },

    handleExitingIntentSelects(event, section) {
      event.stopPropagation();
      let selectedItems = this[`${section}SelectedObjectList`];
      if(selectedItems.length > 0) {
        let cloneItems = [];
        selectedItems.forEach(item => {
          let cloneItem = JSON.parse(JSON.stringify(item));
          cloneItem.status = 'E';
          cloneItem.selected = true;
          cloneItem.originItem = item;
          cloneItem.intentList = null;
          cloneItems.push(cloneItem);
        })

        if(cloneItems.length > 0) {
          this.clonedMessages = cloneItems;
          setTimeout(() => {
            this.$refs.pageModal.open();  
            // this.$refs.existingIntentsPopover.doShow();
          }, 300);
        }
      }
    },

    handlePageModalOpen() {

    },

    handlePageModalClose() {
      this.$refs.pageModal.showModal = false;
      this.$refs.pageModal2.showModal = false;
    },

    handleDiscard(event, item){
      event.stopPropagation();
      if(!localStorage.getItem('noShowNextTime') || localStorage.getItem('noShowNextTime') == 'false') {
        this.noShowNextTime = false;
      }
      else {
        this.noShowNextTime = true;
      }
      // if(!localStorage.getItem('noShowNextTime')) {
      //   this.noShowNextTime = localStorage.getItem('noShowNextTime');
      // }
      // if(!this.noShowNextTime) {
      //   this.$refs.discardDialog.title = `Discard selected messages`;
      //   this.$refs.discardDialog.content="These items will move to the discard list and can be recovered by reverting them to the ‘to be actioned’ list or assigning to a new or existing intent." 
      //   this.$refs.discardDialog.open();
      //   this.$refs.discardDialog.confirmButtonCallback = async () => {
      //     this.discardsConfirmButtonCallback(section, cloneItems, selectedItems);
      //   }
      // }
      // else {
      //   this.discardsConfirmButtonCallback(section, cloneItems, selectedItems);
      // }
      if(!this.noShowNextTime) {
        this.$refs.discardDialog.title = `Discard "${item.message}"?`;
        this.$refs.discardDialog.content="This item will move to the discard list and can be recovered by reverting it to the ‘to be actioned’ list or assigning to a new or existing intent." 
        this.$refs.discardDialog.open();
        this.$refs.discardDialog.confirmButtonCallback = async () => {
          this.discardConfirmButtonCallback(item) 
        }
      }
      else {
        this.discardConfirmButtonCallback(item);
      }
    },

    async discardConfirmButtonCallback(item) {
      let originalStatus = item.status;
      let cloneItem = JSON.parse(JSON.stringify(item));
      cloneItem.status = 'D';
      cloneItem.assignedIntent = null;
      let res = await this.saveOptimizationUnclassifiedMessages([cloneItem]);
      if(res.status == 200) {
        item.status = cloneItem.status;
        item.assignedIntent = cloneItem.assignedIntent;
        //  call api when current page is empty
        if(originalStatus == "E" || originalStatus == "N") {
          this.handlePagenationWhenEmptyMessages('actioned', 'discarded', 1);
          this.pageChanged(this.paginationDiscard.pageNo, 'discarded', this.paginationDiscard)
        }
        if(originalStatus == "I") {
          this.handlePagenationWhenEmptyMessages('toBeActioned', 'discarded', 1);
          this.pageChanged(this.paginationDiscard.pageNo, 'discarded', this.paginationDiscard)
        }
      }
      if(this.noShowNextTime) {
        localStorage.setItem('noShowNextTime', true);
      }
      else {
        localStorage.setItem('noShowNextTime', false);
      }
    },

    handleDiscards(event, section) {
      event.stopPropagation();
      // let messageItems = this[`${section}MessageList`];
      // let selectedItems = this[`${section}Selected`];
      // if(selectedItems.length > 0) {
      //   let cloneItems = [];
      //   this.messageAllList.map(item => {
      //     if(selectedItems.includes(item.message)) {
      //       let cloneItem = JSON.parse(JSON.stringify(item));
      //       cloneItem.status = 'D';
      //       cloneItem.assignedIntent = null;
      //       cloneItem.originItem = item;
      //       cloneItems.push(cloneItem);
      //     }
      //   });
      let selectedItems = this[`${section}SelectedObjectList`];
      if(selectedItems.length > 0) {
        let cloneItems = [];
        selectedItems.forEach(item => {
          let cloneItem = JSON.parse(JSON.stringify(item));
          cloneItem.status = 'D';
          cloneItem.selected = true;
          cloneItem.originItem = item;
          cloneItem.intentList = null;
          cloneItems.push(cloneItem);
        })
      
        if(cloneItems.length > 0) {
          if(!localStorage.getItem('noShowNextTime') || localStorage.getItem('noShowNextTime') == 'false') {
            this.noShowNextTime = false;
          }
          else {
            this.noShowNextTime = true;
          }
          if(!this.noShowNextTime) {
            this.$refs.discardDialog.title = `Discard selected messages`;
            this.$refs.discardDialog.content="These items will move to the discard list and can be recovered by reverting them to the ‘to be actioned’ list or assigning to a new or existing intent." 
            this.$refs.discardDialog.open();
            this.$refs.discardDialog.confirmButtonCallback = async () => {
              this.discardsConfirmButtonCallback(section, cloneItems, selectedItems);
            }
          }
          else {
            this.discardsConfirmButtonCallback(section, cloneItems, selectedItems);
          }
        }
      }
      this.mouseout(event);
    },

    async discardsConfirmButtonCallback(section, cloneItems, selectedItems) {
      let res = await this.saveOptimizationUnclassifiedMessages(cloneItems);
      if(res.status == 200) {
        let numberOfUpdatedItems = selectedItems.length;
        cloneItems.map(cloneItem => {
          let foundMessage = this.messageList.find(item => item.message==cloneItem.message);
          if(foundMessage) {
            foundMessage.status = cloneItem.status;
            foundMessage.assignedIntent = cloneItem.assignedIntent;
          }
        });
        selectedItems.splice(0, selectedItems.length);
        this[`${section}SelectedIsIndeterminate`] = false;
        this[`${section}SelectedCheckAll`] = false;
        this[`${section}Selected`].splice(0, this[`${section}Selected`].length);
        if(this.noShowNextTime) {
          localStorage.setItem('noShowNextTime', true);
        }
        else {
          localStorage.setItem('noShowNextTime', false);
        }

        //  call api when current page is empty
        this.handlePagenationWhenEmptyMessages(section, 'discarded', numberOfUpdatedItems);
        this.pageChanged(this.paginationDiscard.pageNo, 'discarded', this.paginationDiscard)
      }
    },

    updatePagenationSetting(paginationSetting, updateNumber) {
      paginationSetting.totalRecord = paginationSetting.totalRecord + updateNumber;
      if(paginationSetting.pageNo == paginationSetting.pageCount || paginationSetting.pageCount == 0) {
        paginationSetting.pageCount = Math.ceil(paginationSetting.totalRecord/paginationSetting.pageSize)
      }
    },

    // handlePagenationWhenEmptyMessages(fromSection, toSection, numberOfUpdatedItems) {
    handlePagenationWhenEmptyMessages(fromSection) {
      switch(fromSection) {
        case 'toBeActioned':
          if(this.toBeActionedMessageList.length == 0) {
            if(this.paginationToBeActioned.pageNo == this.paginationToBeActioned.pageCount && this.paginationToBeActioned.pageNo > 1) {
              this.pageChanged(this.paginationToBeActioned.pageNo - 1, 'toBeActioned', this.paginationToBeActioned)
            }
            else if(this.paginationToBeActioned.pageNo < this.paginationToBeActioned.pageCount) {
              this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned)
            }
            else if(this.paginationToBeActioned.pageNo == 1){
              this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned)
            }
          }
          else {
            this.pageChanged(this.paginationToBeActioned.pageNo, 'toBeActioned', this.paginationToBeActioned)
          }
          break;
        case 'actioned':
          if(this.actionedMessageList.length == 0) {
            if(this.paginationActioned.pageNo == this.paginationActioned.pageCount && this.paginationActioned.pageNo > 1) {
              this.pageChanged(this.paginationActioned.pageNo - 1, 'actioned', this.paginationActioned)
            }
            else if(this.paginationActioned.pageNo < this.paginationActioned.pageCount) {
              this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned)
            }
            else if(this.paginationActioned.pageNo == 1){
              this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned)
            }
          }
          else {
            this.pageChanged(this.paginationActioned.pageNo, 'actioned', this.paginationActioned)
          }
          break;
        case 'discarded':
          if(this.discardedMessageList.length == 0) {
            if(this.paginationDiscard.pageNo == this.paginationDiscard.pageCount && this.paginationDiscard.pageNo > 1) {
              this.pageChanged(this.paginationDiscard.pageNo - 1, 'discarded', this.paginationDiscard)
            }
            else if(this.paginationDiscard.pageNo < this.paginationDiscard.pageCount) {
              this.pageChanged(this.paginationDiscard.pageNo, 'discarded', this.paginationDiscard)
            }
            else if(this.paginationDiscard.pageNo == 1){
              this.pageChanged(this.paginationDiscard.pageNo, 'discarded', this.paginationDiscard)
            }
          }
          else {
            this.pageChanged(this.paginationDiscard.pageNo, 'discarded', this.paginationDiscard)
          }
          break;
      }
      
      // switch(toSection) {
      //   case 'toBeActioned':
      //     this.updatePagenationSetting(this.paginationToBeActioned, numberOfUpdatedItems);
      //     if(this.messageList.filter(item => item.status=='I').length > this.pageSize) {
      //       this.messageList = this.messageList.filter(item => item.status!='I').concat(this.messageList.filter(item => item.status=='I').slice(0, this.pageSize))
      //     }
      //     break;
      //   case 'actioned':
      //     this.updatePagenationSetting(this.paginationActioned, numberOfUpdatedItems);
      //     if(this.messageList.filter(item => (item.status=='E' || item.status=='N')).length > this.pageSize) {
      //       this.messageList = this.messageList.filter(item => (item.status!='E' && item.status!='N')).concat(this.messageList.filter(item => (item.status=='E' || item.status=='N')).slice(0, this.pageSize))
      //     }
      //     break;
      //   case 'discarded':
      //     console.log(numberOfUpdatedItems)
      //     this.updatePagenationSetting(this.paginationDiscard, numberOfUpdatedItems);
      //     if(this.messageList.filter(item => item.status=='D').length > this.pageSize) {
      //       this.messageList = this.messageList.filter(item => item.status!='D').concat(this.messageList.filter(item => item.status=='D').slice(0, this.pageSize))
      //     }
      //     break;
      // }
      
    },

    reset() {
      this.toBeActionedSelectedIsIndeterminate = false;
      this.toBeActionedSelectedCheckAll = false;
      this.toBeActionedSelected = [];
      this.toBeActionedSelectedDelaySort = [];
      this.toBeActionedSelectedObjectList = [];

      this.actionedSelectedIsIndeterminate = false;
      this.actionedSelectedCheckAll = false;
      this.actionedSelected = [];
      this.actionedSelectedDelaySort = [];
      this.actionedSelectedObjectList = [];

      this.discardedSelectedIsIndeterminate = false;
      this.discardedSelectedCheckAll = false;
      this.discardedSelected = [];
      this.discardedSelectedDelaySort = [];
      this.discardedSelectedObjectList = [];
    },

    handleSelectCategory(item) {
      this.reset();
      this.selectedCategory = item;
      this.loadTopics();
    },

    handleSelectTopic(item) {
      this.reset();
      this.selectedTopic = item;
      this.loadMessages();

      if(this.toBeActionedMessageList && this.toBeActionedMessageList.length > 0){
        this.isToBeActionedCollapseExpanded = false;
      }
      if(this.actionedMessageList && this.actionedMessageList.length > 0){
        this.isActionedCollapseExpanded = false;
      }
      if(this.discardedMessageList && this.discardedMessageList.length > 0){
        this.isDiscardCollapseExpanded = false;
      }
    },

    async pageChanged(pageNumber, type, pagenationSettings) {
      let options = {
        category: this.selectedCategory.name, 
        topic: this.selectedTopic.name, 
        pageSize: pagenationSettings.pageSize, 
        pageNumber: pageNumber,
        keyword: this.keywordSearchConfirmed
      }
      let resMessagesWithToBeActioned = null;
      let resMessagesWithActioned = null;
      let resMessagesWithDiscard = null;
      switch(type) {
        case 'toBeActioned':
          var newToBeActionedList = this.messageList.filter(item => item.status=='I')
          if(newToBeActionedList.length > 0 && this.collapseSelected.includes('toBeActioned')){
            this.loadingToBeActioned = true;
          }
          resMessagesWithToBeActioned = await this.fetchOptimizationUnclassifiedMessagesWithToBeActioned(options);
          this.loadingToBeActioned = false;
          if(resMessagesWithToBeActioned && resMessagesWithToBeActioned.status == 200 && resMessagesWithToBeActioned.data && resMessagesWithToBeActioned.data.data.length > 0) {
            this.messageList = resMessagesWithToBeActioned.data.data.concat(this.messageList.filter(item => item.status!='I'))
            if(this.messageAllList.length == 0) {
              this.messageAllList = JSON.parse(JSON.stringify(this.messageList))
            }
            else {
              this.messageAllList = _.unionBy(this.messageList, this.messageAllList, 'hid');
            }
            this.paginationToBeActioned = {
              pageSize: resMessagesWithToBeActioned.data.pageSize,
              pageCount: resMessagesWithToBeActioned.data.totalPages,
              pageNo: resMessagesWithToBeActioned.data.currentPage,
              totalRecord: resMessagesWithToBeActioned.data.totalRecord
            }
          }
          else {
            this.paginationToBeActioned = {
              pageSize: this.pageSize,
              pageCount: 0,
              pageNo: 1,
              totalRecord: 0
            }
            this.messageList = this.messageList.filter(item => item.status!='I')
          }
          break;
        case 'actioned':
          // this.loadingActioned = true;
          var newActionedList = this.messageList.filter(item => (item.status=='N' || item.status=='E'))
          if(newActionedList.length > 0 && this.collapseSelected.includes('actioned')){
            this.loadingActioned = true;
          }
          resMessagesWithActioned = await this.fetchOptimizationUnclassifiedMessagesWithActioned(options);
          this.loadingActioned = false;
          if(resMessagesWithActioned && resMessagesWithActioned.status == 200 && resMessagesWithActioned.data && resMessagesWithActioned.data.data.length > 0) {
            this.messageList = resMessagesWithActioned.data.data.concat(this.messageList.filter(item => (item.status!='E'&&item.status!='N')))
            this.paginationActioned = {
              pageSize: resMessagesWithActioned.data.pageSize,
              pageCount: resMessagesWithActioned.data.totalPages,
              pageNo: resMessagesWithActioned.data.currentPage,
              totalRecord: resMessagesWithActioned.data.totalRecord
            }
            if(this.messageAllList.length == 0) {
              this.messageAllList = JSON.parse(JSON.stringify(this.messageList))
            }
            else {
              this.messageAllList = _.unionBy(this.messageList, this.messageAllList, 'hid');
            }
          }
          else {
            this.paginationActioned = {
              pageSize: this.pageSize,
              pageCount: 0,
              pageNo: 1,
              totalRecord: 0
            }
            this.messageList = this.messageList.filter(item => (item.status!='E'&&item.status!='N'))
          }
          break;
        case 'discarded':
          var newDiscardedList = this.messageList.filter(item => item.status=='D')
          if(newDiscardedList.length > 0 && this.collapseSelected.includes('discarded')){
            this.loadingDiscarded = true;
          }
          resMessagesWithDiscard = await this.fetchOptimizationUnclassifiedMessagesWithDiscard(options);
          this.loadingDiscarded = false;
          if(resMessagesWithDiscard && resMessagesWithDiscard.status == 200 && resMessagesWithDiscard.data && resMessagesWithDiscard.data.data.length > 0) {
            this.messageList = resMessagesWithDiscard.data.data.concat(this.messageList.filter(item => item.status!='D'))
            this.paginationDiscard = {
              pageSize: resMessagesWithDiscard.data.pageSize,
              pageCount: resMessagesWithDiscard.data.totalPages,
              pageNo: resMessagesWithDiscard.data.currentPage,
              totalRecord: resMessagesWithDiscard.data.totalRecord
            }
            if(this.messageAllList.length == 0) {
              this.messageAllList = JSON.parse(JSON.stringify(this.messageList))
            }
            else {
              this.messageAllList = _.unionBy(this.messageList, this.messageAllList, 'hid');
            }
          }
          else {
            this.paginationDiscard = {
              pageSize: this.pageSize,
              pageCount: 0,
              pageNo: 1,
              totalRecord: 0
            }
            this.messageList = this.messageList.filter(item => item.status!='D')
          }
          break;
        // default:
      }
    },

    pagenationValidation(options, pageNumber) {
      if(options && options.totalRecord) {
        let pageCount = Math.ceil(options.totalRecord/options.pageSize)
        if(pageNumber > pageCount) {
          return pageCount;
        }
        else {
          return pageNumber;
        }
      }
      else {
        return 1;
      }
    },

    async getUnclassifiedMessages(options) {
      this.messageList = null;
      this.keywordSearchConfirmed = this.keywordSearchConfirmed;
      this.loadingMessages = true;
      let resMessagesWithToBeActioned = await this.fetchOptimizationUnclassifiedMessagesWithToBeActioned(options);
      let resMessagesWithActioned = await this.fetchOptimizationUnclassifiedMessagesWithActioned(options);
      let resMessagesWithDiscard = await this.fetchOptimizationUnclassifiedMessagesWithDiscard(options);
      this.loadingMessages = false;

      if(resMessagesWithToBeActioned.status == 200 && resMessagesWithToBeActioned.data && resMessagesWithToBeActioned.data.data.length > 0) {
        this.messageList = resMessagesWithToBeActioned.data.data;
        this.paginationToBeActioned = {
          pageSize: resMessagesWithToBeActioned.data.pageSize,
          pageCount: resMessagesWithToBeActioned.data.totalPages,
          pageNo: resMessagesWithToBeActioned.data.currentPage,
          totalRecord: resMessagesWithToBeActioned.data.totalRecord
        }
      }
      else {
        this.paginationToBeActioned = {
          pageSize: this.pageSize,
          pageCount: 0,
          pageNo: 1,
          totalRecord: 0
        }
      }
      if(resMessagesWithActioned.status == 200 && resMessagesWithActioned.data && resMessagesWithActioned.data.data.length > 0) {
        if(this.messageList && this.messageList.length > 0) {
          this.messageList = this.messageList.concat(resMessagesWithActioned.data.data);
        }
        else {
          this.messageList = resMessagesWithActioned.data.data;
        }
        this.paginationActioned = {
          pageSize: resMessagesWithActioned.data.pageSize,
          pageCount: resMessagesWithActioned.data.totalPages,
          pageNo: resMessagesWithActioned.data.currentPage,
          totalRecord: resMessagesWithActioned.data.totalRecord
        }
      }
      else {
        this.paginationActioned = {
          pageSize: this.pageSize,
          pageCount: 0,
          pageNo: 1,
          totalRecord: 0
        }
      }
      if(resMessagesWithDiscard.status == 200 && resMessagesWithDiscard.data && resMessagesWithDiscard.data.data.length > 0) {
        if(this.messageList && this.messageList.length > 0) {
          this.messageList = this.messageList.concat(resMessagesWithDiscard.data.data);
        }
        else {
          this.messageList = resMessagesWithDiscard.data.data;
        }
        this.paginationDiscard = {
          pageSize: resMessagesWithDiscard.data.pageSize,
          pageCount: resMessagesWithDiscard.data.totalPages,
          pageNo: resMessagesWithDiscard.data.currentPage,
          totalRecord: resMessagesWithDiscard.data.totalRecord
        }
      }
      else {
        this.paginationDiscard = {
          pageSize: this.pageSize,
          pageCount: 0,
          pageNo: 1,
          totalRecord: 0
        }
      }
      if(this.messageList && this.messageList.length == 0) {
        this.messageList = null;
      }
      else {
        this.messageAllList = JSON.parse(JSON.stringify(this.messageList));
      }
      if(this.toBeActionedMessageList.length > 0 && !this.collapseSelected.includes('toBeActioned')) this.collapseSelected.push('toBeActioned');
      if(this.actionedMessageList.length > 0 && !this.collapseSelected.includes('actioned')) this.collapseSelected.push('actioned');
      if(this.discardedMessageList.length > 0 && !this.collapseSelected.includes('discarded')) this.collapseSelected.push('discarded');
    },

    handleKeywordSearch() {
      this.searchMessageKeyword = this.searchMessageKeyword.trim();
      if(this.searchMessageKeyword != this.keywordSearchConfirmed || (this.searchMessageKeyword == this.keywordSearchConfirmed && this.searchMessageKeyword != '')) {
        this.keywordSearchConfirmed = this.searchMessageKeyword;
        this.getUnclassifiedMessages({category: this.selectedCategory.name, topic: this.selectedTopic.name, pageSize: this.pageSize, pageNumber: this.pageNo, keyword: this.keywordSearchConfirmed})
      }
    },

    clearKeywordSearch() {
      this.searchMessageKeyword ='';
      this.handleKeywordSearch();
    },

    highlightKeyword(message, keyword) {
      // keyword = keyword.replace(/[-[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
      keyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      
      var regex = new RegExp('('+keyword+')', 'ig');
      return message.replace(regex, '<span class="highlight">$1</span>');
    },

    async loadCategories() {

      let resCategories = await this.fetchOptimizationUnclassifiedCategories();
      if(resCategories.status == 200 && resCategories.data && resCategories.data.length > 0) {
        this.categoryList = resCategories.data;
        this.selectedCategory = this.categoryList[0];
        this.loadingTopics = true;
        let resTopics = await this.fetchOptimizationUnclassifiedTopics({category: this.selectedCategory.name});
        this.loadingTopics = false;
        if(resTopics.status == 200 && resTopics.data && resTopics.data.length > 0) {
          this.topicList = resTopics.data;
          this.selectedTopic = this.topicList[0];
          this.loading = false;
          this.getUnclassifiedMessages({category: this.selectedCategory.name, topic: this.selectedTopic.name, pageSize: this.pageSize, pageNumber: this.pageNo, keyword: this.keywordSearchConfirmed})
        }
        else {
          this.loading = false;
          this.topicList = null;
          this.selectedTopic = null;
          this.messageList = null;
        }
      }
      else {
        this.loading = false;
        this.categoryList = null;
        this.selectedCategory = null;
        this.topicList = null;
        this.selectedTopic = null;
        this.messageList = null;
      }
    },
    getSelectedObjList(selectedObjectList, newList) {
      if(newList.length > 0) {
        let tempList = [];
        this.messageAllList.forEach(item => {
          if(newList.includes(item.message)) {
            tempList.push(item)
          }
        })
        if(selectedObjectList.length == 0) {
          selectedObjectList = tempList;
        }
        else {
          let list = [];
          _.unionBy(selectedObjectList, tempList, 'hid').forEach(obj => {
            if(newList.includes(obj.message)) {
              list.push(obj)
            }
          })
          selectedObjectList = list
        }
      }
      else {
        selectedObjectList = [];
      }
      return selectedObjectList;
    },
    
    
    async loadTopics() {
      if(this.selectedCategory) {
        this.loadingTopics = true;
        let resTopics = await this.fetchOptimizationUnclassifiedTopics({category: this.selectedCategory.name});
        this.loadingTopics = false;
        if(resTopics.status == 200 && resTopics.data && resTopics.data.length > 0) {
          this.topicList = resTopics.data;
          this.selectedTopic = this.topicList[0];
          this.getUnclassifiedMessages({category: this.selectedCategory.name, topic: this.selectedTopic.name, pageSize: this.pageSize, pageNumber: this.pageNo, keyword: this.keywordSearchConfirmed})
        }
        else {
          this.topicList = null;
          this.selectedTopic = null;
          this.messageList = null;
        }
      }
    },
    
    async loadMessages() {
      if(this.selectedCategory && this.selectedTopic) {
        this.collapseSelected = [];
        
        await this.getUnclassifiedMessages({category: this.selectedCategory.name, topic: this.selectedTopic.name, pageSize: this.pageSize, pageNumber: this.pageNo, keyword: this.keywordSearchConfirmed});
        if(this.messageList) {
          if(this.toBeActionedMessageList.length > 0 && !this.collapseSelected.includes('toBeActioned')) this.collapseSelected.push('toBeActioned');
          if(this.actionedMessageList.length > 0 && !this.collapseSelected.includes('actioned')) this.collapseSelected.push('actioned');
          if(this.discardedMessageList.length > 0 && !this.collapseSelected.includes('discarded')) this.collapseSelected.push('discarded');
        }
      }
    },

    async handleFilterChange() {
      this.reset();
      this.loadCategories();
      this.handlePageModalClose();
    },
  },
  mounted(){
    this.currentPageInfo.tooltip = this.enableSuggestedIntents ? this.$t('tooltips.page.wy-va-optimization-unclassified-messages') : this.$t('tooltips.page.wy-va-optimization-unclassified-messages-without-suggested');

    if(document.querySelector(".el-collapse-item__wrap")){
      document.querySelector(".el-collapse-item__wrap").addEventListener('scroll', () => {
        this.$refs.existingIntentPopover.doClose()
      })
    }
    if(document.querySelector('.existing-intent-popover')){

      document.addEventListener('click', function handleClickOutsideBox(event) {
        const box = document.querySelector('.existing-intent-popover');
        if (box && !box.contains(event.target)) {
          box.style.display = "none";
        }
      });
    } 
    if (document.querySelector('.existing-intents-popover')){
      document.addEventListener('click', function handleClickOutsideBox(event) {
        const box = document.querySelector('.existing-intents-popover');
        if (box && !box.contains(event.target)) {
          box.style.display = "none";
        }
      });
    }
  },
  async created() {
    this.initDate = new Date();
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    });
    this.loading = true;
    let resIntents = await this.fetchOptimizationUnclassifiedIntents();
    if(resIntents.status == 200 && resIntents.data && resIntents.data.length > 0) {
      this.intentList = resIntents.data;
    }
    this.loadCategories();
  },
  destroyed() {
    if(this.isLoggedIn) {
      this.$store.dispatch('amplitudeLogWithFilters', {name: 'optimization_unclassified_page_time_spent', data: {time_spent: WyUtils.getTimeDiff(this.initDate)}});
    }
  }
});
</script> 

<style lang="scss">

table.unclassified-msg-export-table {
  border-collapse: collapse;
  border: 1px solid transparent;
  width: 1071px;
  max-height: 100%;
  overflow: auto;
  color: var(--site-font-tertiary-color);
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14.22px;
  font-weight: 400;
  td {
    height: 20px;
    text-align: left;
    padding: 25px 15px 20px 15px;
    color: var(--site-font-secondary-color);
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14.22px;
    width: fit-content;
    max-width: 249px;
    text-align: left;
    top: 5px;
    position: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    div.ellipsis {
      color: var(--site-font-tertiary-color);
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14.22px;
      padding: 10px 0px !important;
      cursor: pointer;
      width: fit-content;
      max-width: 238px;
      text-align: left;
      // top: 5px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  tr.table-titles {
    border-bottom: 1px #eee solid;
    border-top: 1px #CAD2DA solid;
    width: 100%;
    font-size: 14.5px;
    font-weight: 500;
    td{
      font-weight: 500;
    }
  }
  .el-dialog__header {
    padding: 18px 22px;
    margin-top: 30px;
    color: var(--site-font-tertiary-color);
    padding: 29px 18px 15px 18px;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: 500;
  }
  div.tooltips {
    display:block;
    position:fixed;
    padding: 5px 10px !important;
    font-weight: 500 !important;
    max-width: 350px;
    border-radius: 5px;
    white-space: pre-wrap;
    word-wrap: break-word;
    border: 1px solid #6e7044;
    background-color: #444444;
    color: #FFF;
    // color:red;
    z-index: 999;
    line-height: 18px;
    font-size: 12px !important;
    animation: fadeIn .5s;
    -webkit-animation: fadeIn .5s;
    -moz-animation: fadeIn .5s;
    -o-animation: fadeIn .5s;
    -ms-animation: fadeIn .5s;
  }
  div.tooltips.fadeOut {
    animation: fadeOut .5s;
    -webkit-animation: fadeOut .5s;
    -moz-animation: fadeOut .5s;
    -o-animation: fadeOut .5s;
    -ms-animation: fadeOut .5s;
  }

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes fadeOut {
    0% { opacity: 1; }
    100% { opacity: 0; }
  }
}
.assign-unclassified-msg-to-single-intent-dropdown {
  div.tooltips {
    display:block;
    // position:absolute;
    position: fixed;
    padding: 5px 10px !important;
    font-weight: 500 !important;
    max-width: 350px;
    border-radius: 5px;
    white-space: pre-wrap;
    word-wrap: break-word;
    border: 1px solid #6e7044;
    background-color: #444444;
    color: #FFF;
    // color:red;
    z-index: 999;
    line-height: 18px;
    font-size: 12px !important;
    animation: fadeIn .5s;
    -webkit-animation: fadeIn .5s;
    -moz-animation: fadeIn .5s;
    -o-animation: fadeIn .5s;
    -ms-animation: fadeIn .5s;
  }
  div.tooltips.fadeOut {
    animation: fadeOut .5s;
    -webkit-animation: fadeOut .5s;
    -moz-animation: fadeOut .5s;
    -o-animation: fadeOut .5s;
    -ms-animation: fadeOut .5s;
  }
  .unclassified-msg-icon-flex {
    div.tooltips {
      font-size: 12px;
      right: 5px;
    }
  }

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes fadeOut {
    0% { opacity: 1; }
    100% { opacity: 0; }
  }
}
.unclassified-msg-popper .popper__arrow{
  display: none;
}
.assign-items-to-one-intent-dropdown, .assign-unclassified-msg-to-intent-dropdown {
  div.tooltips {
    display:block;
    position: fixed;
    padding: 5px 10px;
    max-width: 300px;
    border-radius: 5px;
    white-space: pre-wrap;
    word-wrap: break-word;
    border: 1px solid #6e7044;
    background-color: #444444;
    color: #FFF;
    z-index: 999;
    line-height: 18px;
  }
  .el-select-dropdown__wrap.el-scrollbar__wrap {
    position: relative;
  }
}
.assign-unclassified-msg-to-intent-dropdown {
  width: 20.5%;
  .el-select-dropdown__wrap {
    max-height: 260px;
    ul.el-select-dropdown__list > div {
      position: inherit;
      li.el-select-dropdown__item {
        position: inherit;
      }
    }
    .el-select-dropdown__item {
      font-size: 14.22px;
      height: 39px;
    }
    .el-select-dropdown__item:hover {
      background-color: #E8F1FF;
    }
    .el-select-dropdown__item.selected {
      font-weight: 400;
      // color: #106FBC;
    }
  }
}

  .assign-items-to-one-intent-dropdown {
    width: 318px;
    padding-right: 15px;
    max-height: 209px;
    padding-top: 0px;
    border-radius: 5px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    box-shadow: 6px 3px 12px 1px rgba(0, 0, 0, 0.1);
    // margin-top: 84px !important;
    .intent-dropdown-select{
      background: #E8F1FF;
      // color: #106FBC;
      font-weight: 400;
      font-size: 14.22px;
      margin-bottom: 6px;
      margin-top: 6px;
    }
    &::-webkit-scrollbar {
      width: 15px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 50px;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFFFFF;
    }
    &::-webkit-scrollbar:vertical {
      width: 15px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      border-top: none !important;
    }
        
    .el-dropdown-menu__item{
      margin-top: 5px;
      width: 100%;
      max-width: 280px;
      text-align: left;
      color: var(--site-font-secondary-color) !important;
      top: 5px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &:hover {
        background-color: #F4F6F8;
        color: #000000;
      }
    }
  }

.wy-va-optimization-unclassified-messages {
  .suggested-topic .unclassified-table-content, .suggested-category .unclassified-table-content {
    height: calc(100vh - 271px);
    position: relative;
  }
  .messages .unclassified-table-content {
    // height: calc(100vh - 335px);
    height: calc(100vh - 304px);
  }
  
  .div-search-input {
    // width: 575px;
    width: calc(100% - 35px);
    height: 25px;
    display: inline-block;
    position: relative;
    margin-right: 1px;
    margin: 16px;
    border-radius: 5px;
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 1px;
    .search-inp.el-input {
      padding-left: 0px !important;
    }
    .search-button {
      background-color: white;
      border-radius: 8px;
      width: 38px;
      height: 23px;
      text-align: center;
      margin-top: 0px;
      margin-left: 1px;
      padding: 6px 0px 0px 0px;
      font-size: 22px;
      position: absolute;
      z-index: 1;
      background: transparent;
      color: #5C5F62;
      cursor: pointer;
    }
    input.el-input__inner {
      border-width: 1px !important;
      height: 30px;
      font-size: 15px;
      padding-left: 35px;
      padding-right: 30px;
      padding-bottom: 2px;
      border-radius: 5px;
      // width: 575px;
      width: calc(100%);
    }
    input.el-input__inner:focus {
      border-color: #106FBC !important;
      background-color: #FFF !important;
    }
    input.el-input__inner:hover {
      background-color: #F4F6F8;
    }
    .el-input__icon {
      line-height: 25px;
      font-weight: bolder;
      background-image: url('../../assets/icons/icon_search.svg');
      background-repeat: no-repeat;
      background-size: 16px 16px;
      background-position-y: 8px;
      background-position-x: 5px;
    }
    .el-input__icon:before {
      content: '';
    }
    .el-input{
      border: 0px;
      font-size: 14px;
      width: inherit;
      height: 29px;
      padding-left: 10px;
      padding-bottom: 0px;
      width: 100%;
    }
    .fa-times-circle {
      position: relative;
      left: -25px;
      bottom: 0px;
      top: 0px;
      float: right;
      color: #000000;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .div-unclassified-page-infor {
    margin-right: 35%;
  }
  .div-unclassified-pagination-footer {
    display: flex;
    background: #FAFBFB;
    padding-bottom: 9px;
    padding-top: 5px;
    justify-content: flex-end;
    font-size: 14.22px;
    color: #828E9A;
    font-family: 'Helvetica Neue', sans-serif, arial;
    align-items: center;
  }
  .div-unclassified-pagination-footer.no-data {
    background: #FFF;
    justify-content: left;
    padding-left: 15px;
  }
  .div-unclassified-pagination {
  float: right;
  padding-right: 0px;
  // padding-top: 9px;
  height: 20px;
  
  .el-pagination {
    padding-right: 0px;
    display: flex;
    margin-right: 15px;
  }
  .el-pagination button {
    //color: #002852;
    color: #606060;
    font-weight: bold;
    padding-right: 0px;
    margin-left: 10px;
  }
  .btn-prev{
    min-width: 20px;
    height: 20px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border: 1px solid #CAD2DA;
    display: flex;
    align-items: center;
    background-size: 36%;
    // background-position-x: 2px;
    // background-position-y: -5px;
    background-image: url('../../assets/icons/icon_pagenation_prev.svg');
    background-repeat: no-repeat;
    &:hover{
      background-color: #F4F6F8;
    }
  }
  .btn-prev .el-icon, .btn-next .el-icon{
    display: none;
  }
  .btn-next {
    min-width: 20px;
    height: 20px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border: 1px solid #CAD2DA;
    display: flex;
    align-items: center;
    background-size: 36%;
    // background-position-x: 2px;
    // background-position-y: -5px;
    background-image: url('../../assets/icons/icon_pagenation_next.svg');
    background-repeat: no-repeat;
    &:hover{
      background-color: #F4F6F8;
    }
  }
  .el-pagination button.btn-prev:disabled {
    background-image: url('../../assets/icons/icon_page_prev_disable.svg');
  }
  .el-pagination button.btn-next:disabled {
    background-image: url('../../assets/icons/icon_page_next_disable.svg');
  }
  .el-pagination span:not([class*=suffix]) {
    word-spacing: 7px;
    width: 34px;
    height: 34px;
    border-radius: 5px;
    border: 1px solid #CAD2DA;
  }
}
  .header-flex {
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
  }
  span.messages-header {
    color: var(--site-font-secondary-color);
    font-size: 14.5px;
    font-weight: 500;
    font-family: 'Helvetica Neue', arial, sans-serif;
  }
  .unclassified-msg-small-title {
    display: none;
    color: var(--site-font-secondary-color);
    font-size: 15px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 400;
  }
  .el-collapse-item {
    overflow-y: hidden;
    border-top: 1px solid #ebeef5;
  }
  .el-collapse-item:first-child {
    border-top: none;
  }

  .el-dialog__wrapper {
    position: fixed;
    bottom: 0;
    overflow: auto;
    margin: 0;
    top: 73px;
    bottom: 0;
    left: 299px;
    right: 0;
    background: rgba(255, 255, 255, 0.17);
    transition: opacity 500ms;
    visibility: hidden;
    backdrop-filter: blur(2px);
    opacity: 0;
    z-index: 99999 !important;
    visibility: visible;
    opacity: 1;
  }
  .export-popper{
    .export-title {
      color: var(--site-font-tertiary-color);
      font-size: 18px;
      margin: 4px 0px;
    }
    .el-dialog {
      width: fit-content !important;
      border-radius: 8px;
      height: calc(85vh - 115px);
      min-height: 293px;
      margin: 0 auto 0px 0px;
  
      .el-dialog__body {
        padding: 0px !important;
        height: calc(100% - 145px);
        overflow-y: auto;
      }
      .el-dialog__header {
        padding: 18px 22px;
        .el-dialog__headerbtn {
          font-size: 25px !important;
          top: 19px !important;
        }
      }
      .el-dialog__footer {
        border-top: 1px #CAD2DA solid;
        padding: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        span.dialog-footer {
          display: flex;
        }
      }
    }
  
    .export-save-btn{
      color: #FFFFFF;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-weight: 400;
      width: 70px;
      display: flex;
      height: 39px;
      border-radius: 5px;
      background: #0C2837;
      align-items: center;
      justify-content: center;
    }
    .export-cancel-btn{
      width: fit-content;
      height: 39px;
      padding: 10px 22px;
      color: var(--site-font-tertiary-color);
      font-size: 15px;
      background: #FFFFFF;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      border: 1px solid #CAD2DA;
      border-radius: 5px;
      &:hover{
        background: #F4F6F8;
      }
    }
  }
  .header-icon-container {
    display: flex;
    margin-left: 10px;
    align-items: center;
    img.header-delete-icon {
      margin-right: 15px;
      width: 16px;
    }
    .header-reset{
      margin-right: 15px !important;
      cursor: pointer;
    }
    div.tooltips {
      display:block;
      position:absolute;
      padding: 5px 10px;
      width: max-content;
      max-width: 300px;
      border-radius: 5px;
      white-space: pre-wrap;
      word-wrap: break-word;
      border: 1px solid #6e7044;
      background-color: #444444;
      color: #FFF;
      z-index: 999;
      line-height: 18px;
      font-size: 12px;
    }

    .unclassified-msg-icon-flex {
      div.tooltips {
        font-size: 12px;
        // right: 5px;
      }
    }
  }

  .unclassified-messages-title {
    margin-bottom: 42px;
    color: var(--site-font-secondary-color);
    font-size: 25px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
    height: 30px;
    min-width: 1132px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 18px;
    .unclassified-info-icon{
      margin-top: 1px;
      /* font-size: 10px; */
      width: 17px;
      position: relative;
      top: 1px;
    }
  }

  .no-data-flex {
    display: flex;
    flex-direction: column;
    margin-top: 12%;
    align-items: center;
    height: calc(100vh - 320px) !important;
    justify-content: center;
    .no-data-image {
      margin-left: unset !important;
      width: 36%;
    }
  }
  .messages-no-data-flex{
    display: flex;
    flex-direction: column;
    margin-top: 3.3%;
    align-items: center;
    height: calc(100vh - 295px) !important;
    min-height: 372px;
    justify-content: center;
    .no-data-image {
      margin-left: unset !important;
      width: 22%;
    }  
  }
  .percentage-of-total {
    float: right;
  }
  .export-btn {
    box-sizing: border-box;
    border-radius: 5px;
    background: var(--site-button-secondary-btn-background-primary-color);
    color: var(--site-button-secondary-btn-text-primary-color) !important;
    border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
    padding: 6px 15px 9px 11px !important;
    width: 90px;
    font-size: 16px !important;
    font-weight: 500 !important;
    height: 39px;
    float: right;
  }
  .export-btn:hover {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .export-btn:active {
    background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
  }
  .export-btn:focus {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .export-icon {
    background: var(--icon_action_export);
    height: 17px;
    width: 13px;
    position: relative;
    top: 3px;
    height: 17px;
    width: 13px;
    display: inline-block;
    background-repeat: no-repeat;
  }
  .export-text {
    position: relative;
    bottom: 0px;
    left: 5px;
  }
  .box {
    width: 40%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.1);
    padding: 35px;
    border: 2px solid #fff;
    border-radius: 20px/50px;
    background-clip: padding-box;
    text-align: center;
  }

  @media screen and (max-width: 700px) {
    .box{
      width: 70%;
    }
    .popup, .popup2{
      width: 70%;
    }
  }

  .msg-flex-container {
    display: flex;
    div.tooltips {
      display:block;
      position:absolute;
      padding: 5px 10px;
      max-width: 300px;
      border-radius: 5px;
      white-space: pre-wrap;
      word-wrap: break-word;
      border: 1px solid #6e7044;
      background-color: #444444;
      color: #FFF;
      z-index: 999;
      line-height: 18px;
    }
    .current-keyword {
      margin-left: 20px;
      font-size: 12px;
      .keyword-content {
        background-color: #FAE6AC;
      }
    }
  }
  .unclassified-table-no-data{
    // height: calc( 100vh - 700px) !important;
    overflow-y: unset !important;
    min-height: 550px;
    overflow-x: unset !important;
  }
  .unclassified-table {
    border: 1px solid #CAD2DA !important;
    border-right: none !important;
    border-top-right-radius: 0px;
    background-color: #fff;
    width: 35%;
    border-bottom-right-radius: 0px;
    min-width: 320px;
    height: calc( 100vh - 195px);
    overflow-y: hidden;
    overflow-x: hidden;

    .unclassified-percentage {
      float: right;
      margin-right: 10px;
      color: var(--site-font-secondary-color) !important;
    }
    
    .unclassified-msg-edit-delete {
      padding: 5px;
      border-radius: 50%;
      width: 10px;
      background: url('../../assets/icons/icon_unclassified_msg_delete.svg');
      height: 10px;
      position: relative;
      margin-right: 20px;
      background-repeat: no-repeat !important;
      background-position-x: 0.5px;
      background-position-y: 1.5px;
      background-size: 83% !important;
      visibility: hidden;
      cursor: pointer;
    }     

    .last-collapse .el-collapse-item__header {
      border-bottom: none !important;
    }

    .unclassified-msg {
      padding: 0 15px !important;
    }

    // .radio-option {
    //   width: 100%;
    //   line-height: 40px;
    // }

    .unclassified-msg-td {
      border-bottom: 1px solid #CAD2DA;
    }
    
    .unclassified-msg-collapse {
      height: calc(100% - 103px);
      border-top: none !important;
      border-bottom: none !important;
      .el-collapse-item__header {
        font-weight: 550 !important;
        height: 17px;
        background-color: none !important;
        padding: 16px;
        color: var(--site-font-tertiary-color);
        font-size: 14.22px;
        font-weight: 400;
        padding: 12px 6px 12px 15px;
        cursor: pointer;
        margin-bottom: 0px;
        border-bottom: 0px !important;
      }
      .el-collapse-item__header:hover{
        background: #F4F6F8;
      }

      .el-collapse-item__wrap {
        height: calc(100% - 44px);
        border-bottom: none !important;
        overflow-y: hidden;
        overflow-x: hidden;   
        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background: #CAD2DA;
          border-radius: 5px;
        }
      }
      .el-icon-arrow-right:before {
        content: "";
        background-image: url('../../assets/icons/icon_unclassified_msg_arrow.svg');
        background-size: 60%;
        background-position-x: 1px;
        background-position-y: 6px;
        background-repeat: no-repeat;
        height: 16px;
        width: 16px;
        display: inline-block
      }
      .el-collapse-item__arrow.is-active {
        display: inline-block;
        transform: rotate(180deg) !important;
      }
      .el-collapse-item__content {
        padding-bottom: 0em !important;
        overflow-y: scroll;
        overflow-x: hidden;
        height: calc(100% + 4px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &::-webkit-scrollbar {
          width: 15px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 50px;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track {
          background:#FFFFFF;
        }
        &::-webkit-scrollbar:vertical {
          width: 15px;
        }
        &::-webkit-scrollbar-thumb:vertical {
          border-radius: 160px;
          border: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track:vertical {
          border-top: none !important;
        }

        .el-checkbox__label {
          position: inherit;
          color: var(--site-font-drop-down-secondary-color);
        }
      }

      .to-be-actioned-collapse {
        position: relative;
      }
      .actioned-collapse {
        position: relative;
      }
      .discarded-collapse {
        position: relative;
      }

      .el-collapse-item.to-be-actioned-collapse.is-active.is-disabled,
      .el-collapse-item.actioned-collapse.is-active.is-disabled,
      .el-collapse-item.discarded-collapse.is-active.is-disabled {
        .el-collapse-item__header.is-active {
          cursor: default;
          background-color: #FFF;
        }
        .el-collapse-item__arrow.el-icon-arrow-right.is-active {
          display: none;
        }
      }
    }

    .unclassified-msg-checkbox:last-child{
      margin-bottom: 0px;
    }

    .unclassified-msg-checkbox .el-checkbox__label > div{
      color: var(--site-font-tertiary-color)
    }
    .unclassified-msg-checkbox.is-disabled .el-checkbox__label > div {
      color: #CAD2DA;
    }
    .unclassified-msg-checkbox-all.disabled-check-all {
      .el-checkbox__label {
        color: #CAD2DA;
      }
    }
    .unclassified-msg-checkbox-all.disabled-check-all span.el-checkbox__inner {
      background-color: #edf2fc;
      border: 1px solid #CAD2DA !important;
      width: 12px;
      height: 12px;
      outline: none !important;
      cursor: not-allowed;
    }
    .unclassified-msg-checkbox {
      .highlight {
        background-color: #FAE6AC;
      }
    }
    .unclassified-msg-flex-container.message .highlight {
      background-color: #FAE6AC;
    }
    .unclassified-msg-checkbox, .unclassified-msg-checkbox-all {
      line-height: 40px;
      outline: none !important;
      margin-left: 16px;
      //max-width: 349px;
      min-width: 320px;
      .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
        top: 4px !important;
      }
      .el-checkbox__inner {
        border-radius: 3px !important;
        width: 12px;
        height: 12px;
        outline: none !important;
        border: 1px solid var(--primary-checkbox-button-border-color) !important;
      }
      .el-checkbox__inner::after {
        left: 3px;
        top: 2px;
        height: 4px;
      }
      span.el-checkbox__inner:hover {
        -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow)  !important;
        box-shadow: var(--primary-checkbox-button-hover-box-shadow) !important;
      }
      .unclassified-item-label {
        display: inline-block;
        width: 300px;
        white-space: nowrap;
        overflow: hidden;
        max-width: unset !important;
        text-overflow: ellipsis;
      }
      .el-checkbox__input {
        line-height: 0;
      }
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: var(--primary-checkbox-button-check-color);
        border: 1px solid var(--primary-checkbox-button-checked-border-color) !important;
      }
    }
    .unclassified-msg-checkbox.is-checked, .unclassified-msg-checkbox-all.is-checked {
      .el-checkbox__inner {
        background-color: var(--primary-checkbox-button-check-color);
        border: 1px solid var(--primary-checkbox-button-checked-border-color) !important;
      }
    }
    .unclassified-msg-checkbox-all .el-checkbox__inner::after {
      transform: rotate(45deg) scaleY(1);
      // transform: rotate(90deg) scaleY(1);
      // border-bottom: 0;
      left: 2.9px !important;
      color: white !important;
    }


    .unclassified-msg-icon-flex {
      display: flex;
      float: right;
      align-items: center;
    }

    .unclassified-msg-title {
      font-size: 14.5px;
      color: var(--site-font-secondary-color);
      font-weight: 500;
      font-family: 'Helvetics Neue', Arial, Helvetica, sans-serif;
    }
    
    .unclassified-msg-title-percent{
      font-size: 12px;
      color: #636363; 
      font-weight: 400;
      font-family: 'Helvetics Neue', Arial, Helvetica, sans-serif;

      .to-be-actioned-selected-info {
        margin-left: 5px;
        .clear-selected {
          color: #106FBC;
        }
      }
      .actioned-selected-info {
        margin-left: 5px;
        .clear-selected {
          color: #106FBC;
        }
      }
      .discarded-selected-info {
        margin-left: 5px;
        .clear-selected {
          color: #106FBC;
        }
      }
    }

    .unclassified-msg-e-icon {
      background: url('../../assets/icons/icon_unclassified_msg_e.svg');
      background-repeat: no-repeat;
      background-size: 22px;
      width: 22px;
      height: 22px;
      border: 1px solid #CAD2DA;
      border-radius: 4px;
      margin-right: 10px;
      cursor: pointer;
    }
    .unclassified-msg-n-icon {
      background: url('../../assets/icons/icon_unclassified_msg_n.svg');
      background-repeat: no-repeat;
      background-size: 22px;
      width: 22px;
      height: 22px;
      border: 1px solid #CAD2DA;
      border-radius: 4px;
      margin-right: 10px;
      cursor: pointer;
    }
    .e-icon-selected {
      background: url('../../assets/icons/unclassified_msg_e_icon_selected.svg');
      background-repeat: no-repeat;
      background-size: 22px;
      width: 22px;
      height: 22px;
      border-radius: 4px;
      margin-right: 10px;
      cursor: pointer;
    }
    .n-icon-selected {
      background: url('../../assets/icons/unclassified_msg_n_icon_selected.svg');
      background-repeat: no-repeat;
      background-size: 22px;
      width: 22px;
      height: 22px;
      border-radius: 4px;
      margin-right: 10px;
      cursor: pointer;
    }

    .n-icon-selected-delay-active {
      background: url('../../assets/icons/unclassified_msg_n_icon_selected.svg');
      background-repeat: no-repeat;
      background-size: 22px;
      width: 22px;
      height: 22px;
      border-radius: 4px;
      margin-right: 10px;
      cursor: pointer;
    }

    .n-icon-selected-delay-inactive {
      background: url('../../assets/icons/icon_unclassified_msg_n.svg');
      background-repeat: no-repeat;
      background-size: 22px;
      width: 22px;
      height: 22px;
      border-radius: 4px;
      margin-right: 10px;
      cursor: pointer;
    }

    .unclassified-msg-flex-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-items: center;
      min-height: 40px;
      div.tooltips {
        display:block;
        position:absolute;
        padding: 5px 10px !important;
        font-weight: 500 !important;
        max-width: 350px;
        border-radius: 5px;
        white-space: pre-wrap;
        word-wrap: break-word;
        border: 1px solid #6e7044;
        background-color: #444444;
        color: #FFF;
        // color:red;
        z-index: 999;
        line-height: 18px;
        font-size: 12px !important;
        animation: fadeIn .5s;
        -webkit-animation: fadeIn .5s;
        -moz-animation: fadeIn .5s;
        -o-animation: fadeIn .5s;
        -ms-animation: fadeIn .5s;
      }
      div.tooltips.fadeOut {
        animation: fadeOut .5s;
        -webkit-animation: fadeOut .5s;
        -moz-animation: fadeOut .5s;
        -o-animation: fadeOut .5s;
        -ms-animation: fadeOut .5s;
      }
      .unclassified-msg-icon-flex {
        div.tooltips {
          font-size: 12px;
          right: 5px;
        }
      }

      @keyframes fadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
      }
      @keyframes fadeOut {
        0% { opacity: 1; }
        100% { opacity: 0; }
      }
    }
    .unclassified-msg-flex-container.message {
      margin-left: 18px;
      > div {
        font-size: 15px;
        font-weight: normal;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        max-width: 95%;
        color: var(--site-font-secondary-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-height: 20px;
        cursor: pointer;
      }
      > div.tooltips {
        color: #FFF;
      }
    }
    img.header-reset-icon {
      visibility: hidden !important;
      cursor: pointer;
    }
    .unclassified-msg-flex-container:hover {
      .unclassified-msg-edit-delete {
        visibility: visible;
      }
      .header-reset-icon{
        visibility: visible !important;
      }
    }

    .unclassified-table td {
      border-right: 1px solid #CAD2DA;
      padding: 15px;
    }

    .unclassified-table-data {
      color: var(--site-font-tertiary-color);
      font-size: 14.22px;
      font-weight: 400;
      padding: 12px 6px 12px 15px;
      cursor: pointer;
      margin-bottom: 6px;
      margin-top: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:hover{
        background: #F4F6F8;
      }
      &:focus{
        // background: #E8F1FF;
        // color: #1C4DB2;
      }
    }

    /* bottom-left border-radius */
    .unclassified-table-data:first-child {
      border-bottom-left-radius: 5px;
    }
    .unclassified-table-data:last-child {
      border-right: none;
    }

    /* bottom-right border-radius */
    .unclassified-table-data:last-child {
      border-bottom-right-radius: 5px;
    }

    .unclassified-table-title {
      color: var(--site-font-secondary-color);
      font-weight: 500;
      font-size: 16px;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      border-right: none !important;
      border-bottom: 1px solid #CAD2DA;
      padding: 15px;
      background-color: #fff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    .unclassified-table-content {
      overflow: auto;
      &::-webkit-scrollbar {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 50px;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track {
        background:#FFFFFF;
      }
      &::-webkit-scrollbar:vertical {
        width: 15px;
      }
      &::-webkit-scrollbar-thumb:vertical {
        border-radius: 160px;
        border: 4px solid transparent;
        background-clip: content-box;
        background-color: #CAD2DA;
      }
      &::-webkit-scrollbar-track:vertical {
        border-top: none !important;
      }
    }
  }

  .unclassified-table.messages-table {
    .unclassified-table-content {
      overflow: hidden;
      border-top: 1px solid #CAD2DA;
      > div {
        min-height: 180px;
        padding-top: 6px;
        box-sizing: border-box;
        .el-collapse.unclassified-msg-collapse {
          height: 100%;
          border-bottom: unset !important;
          overflow-y: hidden !important;
          .el-collapse-item.is-active {
            height: 100%;
            .el-collapse-item__wrap {
              overflow-y: hidden !important;
              overflow-x: hidden;
              height: calc(100% - 50px);
              .el-collapse-item__content {
                height: 100%;
                // .radio-option {
                //   height: 100%;
                //   display: inline-grid;
                //   align-content: baseline;
                // }
              }
            }
          }
        }
      }
    }
  }

  .unclassified-table:last-child {
    border-right: 1px solid #CAD2DA !important;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 163% !important;
    min-width: 489px;
    position: relative;
  }

  .unclassified-table:first-child{
    border-right: none !important;
    border-top-left-radius: 5px;
    width: 35%;
    border-bottom-left-radius: 5px;
  }

  .unclassified-table-data.category.selected, .unclassified-table-data.topic.selected{
    background: #E8F1FF;
    color: #106FBC;
    // color: #106FBC;
    font-weight: 400;
    font-size: 14.22px;
    margin-bottom: 6px;
    margin-top: 6px;
  }

  .unclassified-msg-checkbox:last-child{
    margin-bottom: 0px;
  }

  .unclassified-msg-checkbox {
    position: inherit;
    line-height: 40px;
    outline: none !important;
    display: flex;
    align-items: center;
    margin-left: 16px;
    width: calc(100% - 116px);

    .el-checkbox__inner {
      border-radius: 0px !important;
      border: 1px solid #CAD2DA !important;
      width: 11px;
      height: 11px;
      outline: none !important;
    }
    .el-checkbox__inner::after {
      left: 3px;
      top: 1px;
      height: 4px;
    }
    .el-checkbox__input {
      line-height: 0;
    }
    span.el-checkbox__inner:hover {
      box-shadow: none !important;
    }
    span.el-checkbox__label {
      width: 100%;
      position: relative;
      > div {
        cursor: pointer;
        font-weight: normal;
        width: fit-content;
        max-width: 90%;
        color: var(--site-font-secondary-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .button-row {
    margin: 20px 0;

    width: fit-content;
    min-width: fit-content;

    display: flex;
    flex-wrap: nowrap;

    .el-button {
      border-radius: 8px;
      font-size: 14px;
      padding: 10px 15px;
    }

    .selected-button {
      color: var(--site-font-tertiary-color);
      font-size: 14px;
      background-color: #FFFFFF;
      border-radius: 90px;
      border: 1px solid #CAD2DA;
      font-weight: 500;
    }
    .el-button:focus {
      color: white;
      font-size: 14px;
      background-color: var(--site-font-tertiary-color);
      border-radius: 90px;
      border: 1px solid #CAD2DA;
      font-weight: 500;
    }
  }

  div.tooltips {
    font-size: 12px !important;
    padding: 5px 10px !important;
    font-weight: 500 !important;
    animation: fadeIn .5s;
    -webkit-animation: fadeIn .5s;
    -moz-animation: fadeIn .5s;
    -o-animation: fadeIn .5s;
    -ms-animation: fadeIn .5s;
  }
  div.tooltips.fadeOut {
    animation: fadeOut .5s;
    -webkit-animation: fadeOut .5s;
    -moz-animation: fadeOut .5s;
    -o-animation: fadeOut .5s;
    -ms-animation: fadeOut .5s;
  }
  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes fadeOut {
    0% { opacity: 1; }
    100% { opacity: 0; }
  }

  .wy-page-modal {
    height: 100%;
    overflow-x: hidden;
    min-width: 1170px;
  }
}

.assign-unclassified-msg-to-intent-dropdown {
  .el-select-dropdown__item.selected{
    background: #E8F1FF !important;
    color: #106FBC !important;
    font-weight: 400;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: #F4F6F8;
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    height: 0px;
  }

  .el-select-group__wrap {
    padding-bottom: 10px;
  }
}

.intent-action-dropdown-cancel-btn{
  color: var(--site-button-cancel-btn-primary-color);
  border: 1px solid var(--site-button-cancel-btn-primary-border-color);
  background-color: transparent;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  width: 70px;
  display: flex;
  height: 39px;
  border-radius: 5px;
  margin-left: 15px;
  background: white;
  align-items: center;
  justify-content: center;
}

.intent-action-dropdown-save-btn{
  cursor: pointer;
  width: fit-content;
  height: 39px;
  padding: 10px 22px;
  font-size: 15px;
  margin-right: 15px;
  background: var(--site-button-primary-btn-background-primary-color);
  color: var(--site-button-primary-btn-text-primary-color) !important;
  border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  border-radius: 5px;
  &:hover{
    background: #F4F6F8;
  }
}

.existing-intents-popover {
  padding: 0px !important;
  height: calc(100% - 375px);
  min-height: 458px;
  max-height: 600px;
  width: 1069px !important;
  border-radius: 5px;
  top: 307px !important;

  .assign-unclassified-msg-to-intent-dropdown {
    .el-select-dropdown__item.selected{
      background: #E8F1FF;
      color: #1C4DB2;
      font-weight: 400;
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
      background-color: #F4F6F8;
    }
  }
  
  .assign-unclassified-msg-to-intent-bottom-flex{
    display: flex;
    justify-content: space-between;
    padding-top: 22px;
    margin-top: 20px;
    border-top: 1px solid #CAD2DA;
    width: 1069px;
    position: fixed;
    bottom: 27px;
  }

  .assign-unclassified-msg-to-intent-header{
    color: var(--site-font-tertiary-color) !important;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 18px;
    padding: 25px 10px 10px 20px !important;
    border-bottom: 1px solid #CAD2DA;
    font-weight: 500;
    a.pop-close-icon {
      font-size: 35px;
      color: #5C5F62;
      cursor: pointer;
      position: relative;
      bottom: 15px;
      font-weight: 200;
      float: right; 
    }
  }

  .assign-unclassified-msg-to-intent-button-row.el-row {
    margin-top: 17px;
    margin-bottom: 10px;
    .el-button{
      padding: 10px 20px !important;
      margin-right: 15px;
      color: var(--site-font-tertiary-color);
      font-weight: 400 !important;
      font-size: 16px;
      border: 1px solid #DCDFE6;
    }
    // .assigned-to-one-intent-style {
    //   border: 1px solid #106FBC;
    //   background: #FFF;
    // }
    .el-button.is-plain:hover {
      background: #F4F6F8;
      border-color: #CAD2DA;
      color: var(--site-font-tertiary-color);
    }
    .el-icon--right {
      margin-left: 5px;
      font-size: 9px;
    }
    .el-input.is-focus .el-input__inner {
      // border-color: #DCDFE6 !important;
      border-color: #106FBC !important;
    }
    .el-input__inner:focus {
      // border-color: #DCDFE6 !important;
      border-color: #106FBC !important;
    }
    .el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
      width: fit-content;
      max-width: 309px;
      text-align: left;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }



  .assign-unclassified-msg-to-intent-table{
    width: 1071px;
    height: calc(100% - 204px);
    tr td.unclassified-msg {
      width: 290px !important;
    }
    tr td.unclassified-msg.disabled-suggested-intent {
      width: 750px !important;
    }
    
    tr.table-titles td.unclassified-msg {
      padding-left: 17px !important;
    }
    .table-flex-container.head-container {
      border-bottom: 1px #CAD2DA solid;
      width: 100%;
    }
    .table-titles {
      font-weight: 500;
      font-size: 14.5px;
    }
    label.el-checkbox.unclassified-msg-checkbox {
      display: flex;
      align-items: center;
      width: inherit;
      span.el-checkbox__inner:hover {
        box-shadow: unset !important;
      }
    }
    .table-flex-container  .el-checkbox__input.is-checked+.el-checkbox__label {
      width: fit-content;
      //max-width: 216px;
      text-align: left;
      color: var(--site-font-secondary-color) !important;
      // top: 5px;
      position: inherit;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .table-flex-container .el-checkbox__label {
      width: fit-content;
      //max-width: 216px;
      text-align: left;
      color: var(--site-font-secondary-color) !important;
      // top: 5px;
      position: inherit;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .table-flex-container {
      .unclassified-msg-checkbox {
        position: inherit;
      }
    }
    span.el-checkbox__label {
      position: inherit;
      width: 100%;
      > div.ellipsis {
        font-weight: normal;
        width: fit-content;
        max-width: 100%;
        color: var(--site-font-secondary-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    
    td.assigned-intent {
      width: 201px !important;
      position: inherit;
      .el-select.el-select--mini {
        margin-left: 0px !important;
        position: inherit;
        width: 100%;
        .el-input.el-input--mini.el-input--suffix {
          position: inherit;
        }
        .el-input__inner {
          padding-left: 0px;
          width: 100%;
          max-width: 309px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .el-input__suffix {
          position: relative;
          .el-input__suffix-inner {
            position: relative;
          }
        }
      }
      .el-select .el-input .el-select__caret {
        color: #C0C4CC;
        font-size: 10px;
        position: absolute;
      }
      .tooltips {
        width: max-content;
        // max-width: 400px;
        // right: -30px;
      }
    }
    td{
      width: 240px;
      height: 20px;
      text-align: left;
      padding: 15px;
      color: var(--site-font-secondary-color);
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14.22px;
    }
    td.classifier-prob{
      width: 160px !important;
      text-align: center;
    }
    td.suggested-intent{
      
      > div.ellipsis {
        width: 300px !important;
        max-width: 238px;
        text-align: left;
        color: var(--site-font-secondary-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }
    }
    div.tooltips {
      display:block;
      position: fixed;
      padding: 5px 10px;
      max-width: 223px;
      width: max-content;
      border-radius: 5px;
      white-space: pre-wrap;
      word-wrap: break-word;
      border: 1px solid #6e7044;
      background-color: #444444;
      color: #FFF !important;
      z-index: 999;
      line-height: 18px;
    }
  }

  .table-boday-container {
    // height: 484px;
    height: 100%;
    min-height: 195px;
    overflow: auto;
    overflow-x: hidden;
    position: inherit;
    &::-webkit-scrollbar {
      width: 15px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 50px;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFFFFF;
    }
    &::-webkit-scrollbar:vertical {
      width: 15px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      border-top: none !important;
    }
  }
}
.unclassified-limitation-warning {
  top: 100px !important;
  // width: fit-content;
  width: 475px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  -webkit-box-shadow: 0px 2px 6px #0000000a;
  box-shadow: 0px 2px 6px #0000000a;
  border-radius: 10px;
  opacity: 1;
  // width: 390px;
  padding: 20px 20px 20px 20px;
  font-weight: normal;
  background: #FBFCDB;
  border: 1px solid #E1B878;
  border-radius: 8px;

  .el-message__content {
    width: 660px;
    font-weight: 700;
    font-size: 15px;
  }

  .el-message__icon.el-icon-info {
    display: none;
  }

  .el-message__content {
    padding-right: 0px !important;
  }

  .el-message__content div {
    padding: 15px 30px 15px 55px;
    color: #8A5608;
  }

  .el-message__closeBtn.el-icon-close {
    top: 15%;
    font-weight: 700;
  }
  .el-message__closeBtn {
    color: #606060;
  }
  .el-message__closeBtn:hover {
    color: #000;
  }
}
</style>